const es = {
  login: {
    login: 'Iniciar sesión',
    loginText: 'Inicia sesión para acceder a tu panel de Zenhammer.',
    email: 'Correo electrónico',
    enterEmail: 'Ingresa tu correo electrónico',
    writePasword: 'Escribe tu contraseña',
    password: 'Contraseña',
    rememberMe: 'Recordarme',
    forgotPassword: '¿Olvidaste tu contraseña?',
    sendResetCode: 'Enviar código de restablecimiento',
    forgotPasswordMessage: 'Ingresa tu correo electrónico para recibir un código de restablecimiento',
    signIn: 'Iniciar sesión',
    resetPassword: 'Restablecer contraseña',
    resetPasswordMessage:
      'Ingresa el código de restablecimiento que recibiste y tu nueva contraseña',
    passwordResetCode: 'Código de restablecimiento de contraseña',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirmar contraseña',
    enterPasswordResetCode: 'Ingresa el código de restablecimiento de contraseña que recibiste',
    writeNewPassword: 'Escribe una nueva contraseña',
    confirmNewPassword: 'Confirma la nueva contraseña',
    passwordsDoNotMatch: 'Las contraseñas no coinciden',
    enterTempPassword: 'Ingresa la contraseña temporal que recibiste',
    tempPassword: 'Contraseña temporal',
    confirmUserMessage:
      'Parece que este es tu primer inicio de sesión, ingresa una nueva contraseña a continuación',
    initialLoginMessage:
      'Deberías haber recibido el mensaje de bienvenida, ingresa la contraseña a continuación',
    // Sprint 28, story-143.
    subtitle: '¿Eres nuevo o vuelves? Ingresa tus datos para continuar.',
    changePasswordToContinue: 'Inicia sesión y cambia tu contraseña para continuar',
    enterPassword: 'Ingresa tu contraseña',
    forgotPasswordTitle: '¿Olvidaste tu contraseña?',
    forgotPasswordSubtitle: 'Ingresa tu correo electrónico para restablecer tu contraseña.',
    sendResetLink: 'Enviar enlace de restablecimiento',
    resetPasswordTitle: 'Restablecer contraseña',
    resetPasswordSubtitle: 'Ingresa tu nueva contraseña y el código de confirmación.',
    enterResetCode: 'Ingresa el código del correo electrónico',
    newPasswordLabel: 'Nueva contraseña',
    confirmPasswordLabel: 'Confirmar contraseña',
    confirmNewPasswordPlaceholder: 'Confirma la nueva contraseña',
    resetPasswordSubmit: 'Restablecer contraseña',
    setNewPasswordTitle: 'Establece una nueva contraseña',
    setNewPasswordSubtitle: 'Establece tu nueva contraseña para continuar.',
    saveNewPassword: 'Guardar nueva contraseña',
    back: 'Atrás',
    noAccount: '¿No tienes una cuenta?',
    signUp: 'Regístrate',
    deeplinkUsed:
      'Este enlace de inicio de sesión ya fue utilizado. Inicia sesión con tu contraseña.',
    invalidEmail: 'Correo electrónico inválido',
    emailRequired: 'El correo electrónico es obligatorio',
    passwordRequired: 'La contraseña es obligatoria',
    codeRequired: 'El código es obligatorio',
    confirmPasswordRequired: 'Confirma tu contraseña',
    // Sprint 28, story-143.
    firstNameRequired: 'El nombre es obligatorio',
    firstNameMinLength: 'El nombre debe tener al menos 2 caracteres',
    lastNameRequired: 'El apellido es obligatorio',
    lastNameMinLength: 'El apellido debe tener al menos 2 caracteres',
    selectOption: 'Selecciona una opción',
    selectHowToGetStarted: 'Selecciona cómo te gustaría comenzar',
    organizationNameRequired: 'El nombre de la organización es obligatorio',
    organizationNameMinLength: 'El nombre de la organización debe tener al menos 2 caracteres',
    selectPlanToContinue: 'Selecciona un plan para continuar',
    // Sprint 28, develop run 3 (story-143 review Warning #2 fix).
    billingPeriodRequired: 'Selecciona un período de facturación',
    billingAddressRequired: 'La dirección es obligatoria',
    billingCityRequired: 'La ciudad es obligatoria',
    billingStateFormat: 'El estado debe tener 2 letras (por ejemplo, CA)',
    billingStateRequired: 'El estado es obligatorio',
    billingZipRequired: 'El código postal es obligatorio',
    cardNumberRequired: 'El número de tarjeta es obligatorio',
    cardNumberInvalid: 'Número de tarjeta inválido',
    cardExpirationRequired: 'La fecha de vencimiento es obligatoria',
    cardExpirationFormat: 'El formato debe ser MM/AA',
    cardExpired: 'La tarjeta venció',
    cvvRequired: 'El CVV es obligatorio',
    cvvFormat: 'El CVV debe tener 3 o 4 dígitos',
    registrationFailed: 'No se pudo completar el registro. Inténtalo de nuevo.',
    registrationError: 'Error de registro',
    unexpectedError: 'Ocurrió un error inesperado. Inténtalo de nuevo.',
    alreadyHaveAccount: 'Ya tienes una cuenta',
    accountAlreadyExists: 'La cuenta ya existe',
    accountRegisteredExplain:
      'Este correo electrónico ya tiene una cuenta de ZenHammer. El registro es solo para cuentas nuevas — las organizaciones adicionales se crean desde dentro de la app.',
    toCreateAnotherOrg: 'Para crear otra organización',
    accountExistsStep1: 'Inicia sesión con este correo',
    accountExistsStep2: 'Abre tu página de Perfil',
    accountExistsStep3: 'Elige "Crear organización"',
    accountInvitedExplain:
      'Este correo electrónico ya está registrado en nuestro sistema. Anteriormente fuiste invitado a unirte a una organización.',
    whatShouldIDo: '¿Qué debo hacer?',
    checkInboxForInvite: 'Revisa tu bandeja de entrada para ver el correo de invitación',
    checkSpamFolder: 'Revisa tu carpeta de spam o correo no deseado',
    useForgotPasswordHint: 'Usa "¿Olvidaste tu contraseña?" si necesitas restablecer tus credenciales',
    goToLogin: 'Ir a iniciar sesión',
    forgotPasswordButton: '¿Olvidaste tu contraseña?',
    useDifferentEmail: 'Usar un correo electrónico diferente',
    noInvitationFoundTitle: 'No se encontró ninguna invitación',
    noInvitationFoundFor: 'No pudimos encontrar una invitación para {email}',
    checkEmailOrCreateOrg:
      'Revisa tu correo electrónico para ver un enlace de invitación, o crea tu propia organización para comenzar.',
    createAnOrganizationButton: 'Crear una organización',
    orWaitForInvitation: 'o espera un correo de invitación',
    whatsNext: '¿Qué sigue?',
    whatsNextDetail:
      'Si esperas una invitación, revisa tu bandeja de entrada y la carpeta de spam. Si quieres empezar a usar Zenhammer de inmediato, puedes crear tu propia organización.',
    couldNotLoadPlans: 'No se pudieron cargar los planes',
    couldNotLoadPlansMessage:
      'No pudimos cargar los planes de suscripción disponibles. Actualiza la página e inténtalo de nuevo.',
    noPlansAvailable: 'No hay planes disponibles',
    noPlansAvailableMessage:
      'No hay planes de suscripción disponibles en este momento, por lo que no se puede crear una nueva organización. Contacta a soporte.',
    yourPlan: 'Tu plan',
    chooseYourPlan: 'Elige tu plan',
    yourPlanStartHint: 'Esto es con lo que iniciará tu organización.',
    choosePlanHint:
      'Elige el plan con el que iniciará tu organización. La duración de la prueba y si se requiere una tarjeta por adelantado varían según el plan.',
    selectYourPlan: 'Selecciona tu plan',
    createAccount: 'Crear cuenta',
    creatingAccount: 'Creando cuenta...',
    createAccountAndStartTrial: 'Crear cuenta e iniciar prueba',
    createYourAccount: 'Crea tu cuenta',
    joinAndManage: 'Únete a Zenhammer y empieza a gestionar tus proyectos de construcción',
    alreadyHaveAccountQuestion: '¿Ya tienes una cuenta?',
    personalInformation: 'Información personal',
    firstNameLabel: 'Nombre',
    lastNameLabel: 'Apellido',
    firstNamePlaceholder: 'Ingresa tu nombre',
    lastNamePlaceholder: 'Ingresa tu apellido',
    confirmYourPassword: 'Confirma tu contraseña',
    organizationInformation: 'Información de la organización',
    organizationNameLabel: 'Nombre de la organización',
    organizationNamePlaceholder: 'Ingresa el nombre de tu organización',
    howWouldYouLikeToStart: '¿Cómo te gustaría comenzar?',
    invitedOptionTitle: 'Fui invitado a unirme a una organización',
    invitedOptionDesc:
      'Recibiste una invitación por correo para unirte al espacio de trabajo de tu empresa en Zenhammer. Completa tu registro para acceder a los proyectos de tu equipo.',
    noPaymentRequired: 'No se requiere pago',
    createOptionTitle: 'Quiero crear una nueva organización',
    createOptionDesc:
      'Crea tu propio espacio de trabajo de Zenhammer para tu empresa. Configurarás la facturación e invitarás a los miembros de tu equipo.',
    choosePlanNext: 'A continuación elige tu plan',
    continueButton: 'Continuar',
    paymentDetailsStep: 'Detalles de pago',
    planRequiresCard: 'El plan {plan} requiere una tarjeta para comenzar.',
    planStepTitle: 'Plan de suscripción',
    personalInfoStepTitle: 'Información personal',
    organizationStepTitle: 'Organización',
    paymentStepTitle: 'Pago',
    trialPlanSummary: 'Tu organización inicia con una prueba gratuita de {days} días de {plan}.',
    billedImmediatelyPlanSummary: 'Tu organización inicia en {plan}, con facturación inmediata.',
    noCardRequiredHint:
      'No se requiere tarjeta de crédito: te pediremos los datos de pago cuando termine la prueba.',
    cardRequiredHint: 'Se requiere una tarjeta de crédito para completar el registro.',
    paymentMethodLabel: 'Método de pago',
    creditOrDebitCard: 'Tarjeta de crédito o débito',
    cardBrandsHint: 'Visa, Mastercard, Amex o Discover',
    billingInformation: 'Información de facturación',
    address: 'Dirección',
    city: 'Ciudad',
    state: 'Estado',
    zipCode: 'Código postal',
    phone: 'Teléfono',
    cardInformation: 'Información de la tarjeta',
    cardNumber: 'Número de tarjeta',
    expirationDate: 'Vencimiento (MM/AA)',
    cvv: 'Código CVV',
    paymentSecureHint:
      'Tu información de pago está tokenizada y cifrada de forma segura. Los datos de la tarjeta nunca se almacenan en nuestros servidores.',
  },
  //TODO: I would refactor these using element + action to avoid so much repetition
  actionMessages: {
    // Sprint 31, story-160/161. Asistente de proyectos + generación de planes con IA.
    planImportedSuccessfully: 'Plan importado correctamente',
    templateImportFailedAfterCreate:
      'No se pudieron importar las tareas de la plantilla. Puedes importar una desde el cronograma.',
    planSavedAsTemplate: 'Plan guardado como plantilla',
    planGenerationFailed: 'No se pudo generar el plan',
    deleteSuccessful: 'Eliminado correctamente',
    updateSuccessful: 'Actualizado correctamente',
    profileUpdatedSuccessfully: 'Perfil actualizado correctamente',
    organizationCreatedSuccessfully: 'Organización creada correctamente',
    organizationEditedSuccessfully: 'Organización editada correctamente',
    organizationEnabledSuccessfully: 'Organización habilitada correctamente',
    organizationDisabledSuccessfully: 'Organización eliminada correctamente',
    userCreatedSuccessfully: 'Usuario creado correctamente',
    userEditedSuccessfully: 'Usuario editado correctamente',
    userDisabledSuccessfully: 'Usuario eliminado correctamente',
    userEnabledSuccessfully: 'Usuario habilitado correctamente',
    loginNoEmail:
      'Sin correo electrónico, ingresa tu correo y haz clic en "Olvidé mi contraseña" nuevamente',
    // Sprint 31, develop run 3 (Priority 1). ALL toast/alert copy, deduped across call sites.
    // Auth & session
    checkYourCredentials: 'Verifica tus credenciales',
    // Sprint 52, story-265. Mensajes específicos de inicio de sesión según el errorCode del backend.
    loginPasswordResetRequired: 'Debes restablecer tu contraseña. Haz clic en "Olvidé mi contraseña" para elegir una nueva.',
    loginUserNotConfirmed: 'Tu cuenta aún no está confirmada. Revisa tu correo para encontrar el enlace de configuración.',
    loginTempPasswordExpired: 'Tu contraseña temporal venció. Haz clic en "Olvidé mi contraseña" para recibir un nuevo enlace de configuración.',
    loginTooManyAttempts: 'Demasiados intentos de inicio de sesión. Espera unos minutos e inténtalo de nuevo.',
    loginCouldNotReachServer: 'No se pudo conectar con el servidor. Revisa tu conexión e inténtalo de nuevo.',
    invalidVerificationCode: 'El código de verificación no es válido. Inténtalo de nuevo.',
    loggedInSuccessfully: 'Sesión iniciada correctamente',
    passwordChangeSuccessful: 'Contraseña cambiada correctamente',
    passwordResetSuccessfully: 'Contraseña restablecida correctamente',
    passwordSetSuccessfully: 'Contraseña establecida correctamente',
    passwordUpdatedSuccessfully: 'Contraseña actualizada correctamente',
    pleaseChangeYourPassword: 'Cambia tu contraseña',
    sessionExpiredSignInAgain: 'La sesión expiró. Vuelve a iniciar sesión.',
    // Billing & subscriptions
    addonAddedSuccessfully: 'Complemento agregado correctamente',
    addonRemovedSuccessfully: 'Complemento eliminado correctamente',
    askAdminToAddSeats: 'Pídele a tu propietario o administrador que agregue puestos.',
    defaultPaymentMethodUpdatedSuccessfully: 'Método de pago predeterminado actualizado correctamente',
    paymentAccountConnected: 'Cuenta de pago conectada',
    paymentAccountRemoved: 'Cuenta de pago eliminada',
    paymentMethodAddedSuccessfully: 'Método de pago agregado correctamente',
    paymentMethodDeletedSuccessfully: 'Método de pago eliminado correctamente',
    planAssignedSuccessfully: 'Plan asignado correctamente',
    trialExtendedSuccessfully: 'Período gratuito extendido',
    subscriptionActiveFullAccessRestored: 'Tu suscripción está activa. Se restauró el acceso completo.',
    subscriptionPausedSuccessfully: 'Suscripción pausada correctamente',
    subscriptionPlanCreatedSuccessfully: 'Plan de suscripción creado correctamente',
    subscriptionPlanDeletedSuccessfully: 'Plan de suscripción eliminado correctamente',
    subscriptionPlanUpdatedSuccessfully: 'Plan de suscripción actualizado correctamente',
    subscriptionReactivatedSuccessfully: '¡Suscripción reactivada correctamente!',
    subscriptionResumedSuccessfully: 'Suscripción reanudada correctamente',
    subscriptionStartedSuccessfully: '¡Suscripción iniciada correctamente! La facturación comenzará en tu próxima fecha de facturación.',
    // Budgets & line items
    budgetProposalAcceptedSuccessfully: 'Propuesta de presupuesto aceptada correctamente',
    budgetProposalRejected: 'Propuesta de presupuesto rechazada',
    budgetProposalSubmittedSuccessfully: 'Propuesta de presupuesto enviada correctamente',
    budgetRequestAcceptedSuccessfully: 'Solicitud de presupuesto aceptada correctamente',
    budgetRequestCancelled: 'Solicitud de presupuesto cancelada',
    budgetRequestCreatedSuccessfully: 'Solicitud de presupuesto creada correctamente',
    budgetRequestRejected: 'Solicitud de presupuesto rechazada',
    counterProposalSubmittedSuccessfully: 'Contrapropuesta enviada correctamente',
    lineItemCreatedSuccessfully: 'Partida creada correctamente',
    lineItemDeleted: 'Partida eliminada',
    lineItemUpdated: 'Partida actualizada',
    // Categories
    categoryCreatedSuccessfully: 'Categoría creada correctamente',
    categoryDeletedSuccessfully: 'Categoría eliminada correctamente',
    categoryUpdatedSuccessfully: 'Categoría actualizada correctamente',
    failedToDeleteCategory: 'No se pudo eliminar la categoría',
    failedToDelete: 'No se pudo eliminar',
    failedToSaveCategory: 'No se pudo guardar la categoría',
    // Clients
    clientCreatedInvitationFailed: 'El cliente se creó, pero no se pudo enviar la invitación. Vuelve a intentarlo desde la pestaña de acceso del cliente.',
    clientCreatedSuccessfully: 'Cliente creado correctamente',
    clientDeletedSuccessfully: 'Cliente eliminado correctamente',
    clientUpdatedSuccessfully: 'Cliente actualizado correctamente',
    noClientWasDeleted: 'No se eliminó ningún cliente',
    // Crews & employees
    crewCreatedSuccessfully: 'Cuadrilla creada correctamente',
    crewDeletedSuccessfully: 'Cuadrilla eliminada correctamente',
    crewMembersUpdatedSuccessfully: 'Miembros de la cuadrilla actualizados correctamente',
    crewTasksUpdatedSuccessfully: 'Tareas de la cuadrilla actualizadas correctamente',
    crewUpdatedSuccessfully: 'Cuadrilla actualizada correctamente',
    employeeUnassignedSuccessfully: 'Empleado desasignado correctamente',
    errorFetchingCrew: 'Error al obtener la cuadrilla',
    // Documents
    documentDeletedSuccessfully: 'Documento eliminado correctamente',
    documentUpdatedSuccessfully: 'Documento actualizado correctamente',
    documentUploadedSuccessfully: 'Documento subido correctamente',
    failedToDeleteDocument: 'No se pudo eliminar el documento',
    // Geofences
    geofenceCreated: 'Geocerca creada',
    geofenceUpdated: 'Geocerca actualizada',
    failedToSaveGeofence: 'No se pudo guardar la geocerca',
    failedToUpdateStatus: 'No se pudo actualizar el estado',
    // Incidents
    incidentAcknowledgedSuccessfully: 'Incidente reconocido correctamente',
    // Invoices
    connectPaymentAccountToResend: 'Conecta una cuenta de pago antes de reenviar esta factura.',
    connectPaymentAccountToSend: 'Conecta una cuenta de pago antes de enviar esta factura.',
    invoiceSent: 'Factura enviada',
    invoiceVoided: 'Factura anulada',
    // Misc
    couldNotCopyLink: 'No se pudo copiar el enlace',
    delegationCancelledSuccessfully: 'Delegación cancelada correctamente',
    draftDeleted: 'Borrador eliminado',
    emailIsRequired: 'El correo electrónico es obligatorio',
    errorFetchingActivities: 'Error al obtener las actividades',
    failedToMoveReservation: 'No se pudo mover la reserva',
    failedToResizeReservation: 'No se pudo cambiar el tamaño de la reserva',
    failedToSetMaintenanceStatus: 'No se pudo establecer el estado de mantenimiento',
    noInvitationFoundForEmail: 'No se encontró ninguna invitación para este correo electrónico.',
    registrationSuccessfulWelcome: '¡Registro exitoso! Bienvenido a ZenHammer.',
    registrationFailed: 'No se pudo completar el registro',
    reservationMovedSuccessfully: 'Reserva movida correctamente',
    reservationUpdatedSuccessfully: 'Reserva actualizada correctamente',
    // Notification recipients
    recipientAdded: 'Destinatario agregado',
    recipientDeleted: 'Destinatario eliminado',
    recipientUpdated: 'Destinatario actualizado',
    // Organizations
    defaultOrganizationUpdatedSuccessfully: 'Organización predeterminada actualizada correctamente',
    failedToCheckOrganizationStatus: 'No se pudo verificar el estado de la organización',
    organizationActiveRedirecting: '¡La organización está activa! Redirigiendo...',
    organizationCreatedRedirecting: '¡Organización creada correctamente! Redirigiendo...',
    organizationCreatedTrialStarts: 'Organización creada. Tu prueba gratuita comienza ahora.',
    organizationStillSuspended: 'La organización sigue suspendida.',
    organizationUpdatedSuccessfully: 'Organización actualizada correctamente',
    // Projects
    errorFetchingProjectBudgetSummary: 'Error al obtener el resumen de presupuesto del proyecto',
    noProjectSelectedReopen: 'No hay ningún proyecto seleccionado. Vuelve a abrir el proyecto e inténtalo de nuevo.',
    noProjectWasDeleted: 'No se eliminó ningún proyecto',
    projectCreatedSuccessfully: 'Proyecto creado correctamente',
    projectDeletedSuccessfully: 'Proyecto eliminado correctamente',
    projectIdCopiedToClipboard: 'ID del proyecto copiado al portapapeles',
    projectStatusUpdatedSuccessfully: 'Estado del proyecto actualizado correctamente',
    projectUpdatedSuccessfully: 'Proyecto actualizado correctamente',
    // Tasks
    subtaskCreatedSuccessfully: 'Subtarea creada correctamente',
    taskCreatedSuccessfully: 'Tarea creada correctamente',
    tasksImportedSuccessfully: 'Tareas importadas correctamente',
    taskTemplateCreatedSuccessfully: 'Plantilla de tarea creada correctamente',
    taskTemplateDeletedSuccessfully: 'Plantilla de tarea eliminada correctamente',
    taskUpdatedSuccessfully: 'Tarea actualizada correctamente',
    // Users & settings
    avatarUpdatedSuccessfully: 'Avatar actualizado correctamente',
    errorLoadingUserData: 'Error al cargar los datos del usuario',
    minimumVersionUpdatedSuccessfully: 'Versión mínima actualizada correctamente',
    roleIsRequired: 'El rol es obligatorio',
    roleUpdatedSuccessfully: 'Rol actualizado correctamente',
    settingCreatedSuccessfully: 'Configuración creada correctamente',
    settingDeletedSuccessfully: 'Configuración eliminada correctamente',
    settingUpdatedSuccessfully: 'Configuración actualizada correctamente',
    userStatusUpdatedSuccessfully: 'Estado del usuario actualizado correctamente',
    userUpdatedSuccessfully: 'Usuario actualizado correctamente',
    // Warehouse, materials & equipment
    assetAssignedToEquipment: 'Activo asignado al equipo',
    defaultWarehouseUpdatedSuccessfully: 'Almacén predeterminado actualizado correctamente',
    equipmentAddedFromWarehouse: 'Equipo agregado desde el almacén',
    equipmentAddedManually: 'Equipo agregado manualmente',
    equipmentAssetCodeExists: 'Ya existe un equipo con este código de activo. Usa un código diferente.',
    equipmentAssetsExportedSuccessfully: 'Activos de equipo exportados correctamente',
    equipmentCheckedOut: 'Equipo retirado',
    equipmentCheckedOutSuccessfully: 'Equipo retirado correctamente',
    equipmentCreatedSuccessfully: 'Equipo creado correctamente',
    equipmentDeletedSuccessfully: 'Equipo eliminado correctamente',
    equipmentNameExists: 'Ya existe un equipo con este nombre. Usa un nombre diferente.',
    equipmentRemoved: 'Equipo eliminado',
    equipmentReturned: 'Equipo devuelto',
    equipmentReturnedSuccessfully: 'Equipo devuelto correctamente',
    equipmentSetToMaintenance: 'Equipo puesto en mantenimiento',
    equipmentUpdated: 'Equipo actualizado',
    equipmentUpdatedSuccessfully: 'Equipo actualizado correctamente',
    errorFetchingMaterialsAndEquipment: 'Error al obtener los materiales y equipos',
    failedToCheckoutEquipment: 'No se pudo retirar el equipo',
    failedToDeleteEquipment: 'No se pudo eliminar el equipo',
    failedToDeleteMaterial: 'No se pudo eliminar el material',
    failedToExportEquipmentAssets: 'No se pudieron exportar los activos de equipo',
    failedToExportMaterialCatalog: 'No se pudo exportar el catálogo de materiales',
    failedToExportTransactionHistory: 'No se pudo exportar el historial de movimientos',
    failedToReturnEquipment: 'No se pudo devolver el equipo',
    failedToSaveEquipment: 'No se pudo guardar el equipo. Inténtalo de nuevo.',
    failedToSaveMaterial: 'No se pudo guardar el material',
    materialAddedFromWarehouse: 'Material agregado desde el almacén',
    materialCatalogExportedSuccessfully: 'Catálogo de materiales exportado correctamente',
    materialCreatedInitialStockFailed: 'El material se creó, pero no se pudieron agregar las existencias iniciales',
    materialCreatedSuccessfully: 'Material creado correctamente',
    materialCreatedWithInitialStock: 'Material creado con existencias iniciales',
    materialDeletedSuccessfully: 'Material eliminado correctamente',
    materialMarkedAsConsumed: 'Material marcado como consumido',
    materialRemoved: 'Material eliminado',
    materialReservedFromWarehouse: 'Material reservado desde el almacén',
    materialReturnedToWarehouse: 'Material devuelto al almacén',
    materialUpdated: 'Material actualizado',
    materialUpdatedSuccessfully: 'Material actualizado correctamente',
    plannedEquipmentAdded: 'Equipo planificado agregado',
    plannedMaterialAdded: 'Material planificado agregado',
    stockAdjustedSuccessfully: 'Existencias ajustadas correctamente',
    transactionHistoryExportedSuccessfully: 'Historial de movimientos exportado correctamente',
    warehouseCreatedSuccessfully: 'Almacén creado correctamente',
    warehouseDeletedSuccessfully: 'Almacén eliminado correctamente',
    warehouseUpdatedSuccessfully: 'Almacén actualizado correctamente',
    // Sprint 31, develop run 3 (Priority 1 follow-up). Toast/Alert fallback literals
    // (guard-invisible: the toast/Alert arg was a `||`/ternary chain, not a bare string).
    // Billing & subscriptions
    couldNotActivateSubscription: 'No se pudo activar la suscripción.',
    failedToAddAddon: 'No se pudo agregar el complemento',
    failedToAddPaymentMethod: 'No se pudo agregar el método de pago',
    failedToAssignPlan: 'No se pudo asignar el plan',
    failedToExtendTrial: 'No se pudo extender el período gratuito',
    failedToCancelSubscription: 'No se pudo cancelar la suscripción',
    failedToDeletePaymentMethod: 'No se pudo eliminar el método de pago',
    failedToLinkAddon: 'No se pudo vincular el complemento',
    failedToPauseSubscription: 'No se pudo pausar la suscripción',
    failedToRepriceAddon: 'No se pudo actualizar el precio del complemento',
    failedToResumeSubscription: 'No se pudo reanudar la suscripción',
    failedToStartSubscription: 'No se pudo iniciar la suscripción',
    failedToUnlinkAddon: 'No se pudo desvincular el complemento',
    failedToUpdateDefaultPaymentMethod: 'No se pudo actualizar el método de pago predeterminado',
    // Budgets & line items
    errorCreatingLineItem: 'Error al crear la partida',
    errorDeletingLineItem: 'Error al eliminar la partida',
    errorUpdatingLineItem: 'Error al actualizar la partida',
    // Clients
    clientAccessUpdated: 'Acceso del cliente actualizado',
    failedToDeleteClient: 'No se pudo eliminar el cliente',
    // Crews
    failedToDeleteCrew: 'No se pudo eliminar la cuadrilla',
    // Geofences
    geofenceDisabled: 'Geocerca deshabilitada',
    failedToUpdateGeofence: 'No se pudo actualizar la geocerca',
    geofenceEnabled: 'Geocerca habilitada',
    // Incidents
    failedToReportIncident: 'No se pudo reportar el incidente',
    incidentReportedSuccessfully: 'Incidente reportado correctamente',
    // Misc
    failedToImportTasksFromTemplate: 'No se pudieron importar las tareas desde la plantilla',
    invitationResent: 'Invitación reenviada.',
    invitationSent: 'Invitación enviada.',
    requestError: 'Error en la solicitud',
    // Notification recipients
    recipientDisabled: 'Destinatario deshabilitado',
    recipientEnabled: 'Destinatario habilitado',
    // Field Capture admin (sprint 31, orchestrator scope reversal — see i18n-scope-rules.md §7)
    failedToRegenerateLinks: 'No se pudieron regenerar los enlaces',
    linksAlreadyUpToDate: 'Los enlaces ya están actualizados',
    uploadFailed: 'No se pudo subir el archivo',
    batchApplied: 'Lote aplicado — enlaces de tienda regenerados',
    applyFailed: 'No se pudo aplicar el lote',
    batchDiscarded: 'Lote descartado',
    discardFailed: 'No se pudo descartar el lote',
    projectLinkedToStore: 'Proyecto vinculado a todas las terminales de esta tienda',
    projectUnlinked: 'Proyecto desvinculado',
    failedToLinkProject: 'No se pudo vincular el proyecto',
    submissionResolvedAndProcessed: 'Envío resuelto y procesado',
    failedToResolveSubmission: 'No se pudo resolver el envío',
    exportFailed: 'No se pudo exportar',
    ocrRunFailed: 'No se pudo ejecutar el OCR',
    couldNotResolveSerial: 'No se pudo resolver el número de serie',
    // Organizations
    couldNotCreateOrganization: 'No se pudo crear la organización.',
    invoicingPausedForOrganization: 'Facturación pausada para la organización',
    invoicingResumedForOrganization: 'Facturación reanudada para la organización',
    organizationDisabledStatusSuccessfully: 'Organización deshabilitada correctamente',
    // Projects
    failedToDeleteProject: 'No se pudo eliminar el proyecto',
    // Task templates
    failedToCreateTaskTemplate: 'No se pudo crear la plantilla de tarea',
    failedToDeleteTaskTemplate: 'No se pudo eliminar la plantilla de tarea',
    // Users
    userDisabledStatusSuccessfully: 'Usuario deshabilitado correctamente',
  },
  menu: {
    dashboard: 'Tablero',
    mapView: 'Vista de mapa',
    clients: 'Clientes',
    employees: 'Empleados',
    crews: 'Cuadrillas',
    subcontractors: 'Subcontratistas',
    projects: 'Proyectos',
    inventory: 'Inventario',
    reports: 'Informes',
    invoices: 'Facturas',
    schedule: 'Cronograma',
    permits: 'Permisos',
    insurance: 'Seguro',
    organizations: 'Organizaciones',
    settings: 'Configuración',
    logout: 'Cerrar sesión',
    users: 'Usuarios',
    searchResultsMinLength: 'Escribe al menos tres caracteres',
    // Sprint 28, story-142.
    documents: 'Documentos',
    templates: 'Plantillas',
    incidents: 'Incidentes',
    warehouse: 'Almacén',
    geofences: 'Geocercas',
    billing: 'Facturación',
    bids: 'Ofertas',
    subscriptionPlans: 'Planes de suscripción',
    userAdmin: 'Administración de usuarios',
    warehouseConfig: 'Configuración de almacén',
    notificationRecipients: 'Destinatarios de notificaciones',
    createInvoice: 'Crear factura',
    fieldCapture: 'Captura de campo',
    platformStatus: 'Estado de la plataforma',
    tutorials: 'Tutoriales',
    uiComponents: 'Componentes de interfaz',
    assistant: 'Asistente',
    dailyReports: 'Reportes diarios',
  },
  settings: {
    changeAvatar: 'Cambiar avatar',
    saveAvatar: 'Guardar avatar',
    changePassword: 'Cambiar contraseña',
    oldPassword: 'Contraseña actual',
    newPassword: 'Nueva contraseña',
    confirmNewPassword: 'Confirmar nueva contraseña',
    updatePassword: 'Actualizar contraseña',
    saveName: 'Guardar nombre',
    saveLanguage: 'Guardar idioma',
    english: 'Inglés',
    spanish: 'Español',
    // Sprint 27, story-139.
    language: 'Idioma',
    languageUpdated: 'Idioma actualizado',
    languageUpdateError: 'No se pudo actualizar el idioma. Inténtalo de nuevo.',
    // Sprint 28, story-142. "In progress" tier — docs/ux/i18n-house-style.md §7.
    autoDetectHint:
      'Estamos traduciendo ZenHammer al español. Todavía verás algunas pantallas en inglés hasta que terminemos.',
    autoDetectHintGotIt: 'Entendido',
    autoDetectBanner: 'Configuramos ZenHammer en {language} según tu dispositivo. Puedes cambiarlo cuando quieras en tu Perfil.',
    // Sprint 28, story-142.
    profileTitle: 'Perfil de usuario',
    firstName: 'Nombre',
    lastName: 'Apellido',
    enterFirstName: 'Ingresa el nombre',
    enterLastName: 'Ingresa el apellido',
    enterOldPassword: 'Ingresa la contraseña actual',
    enterNewPassword: 'Ingresa la nueva contraseña',
    updatePasswordButton: 'Actualizar contraseña',
    myOrganizations: 'Mis organizaciones',
    myOrganizationsHint: 'Administra y cambia entre tus organizaciones',
    createOrganization: 'Crear organización',
    createFirstOrganization: 'Crea tu primera organización',
    noOrganizationsYet: 'Aún no tienes organizaciones',
    minVersion: 'Versión mínima',
    minVersionPlaceholder: 'p. ej. 1.2.3',
    updateMinVersion: 'Actualizar versión mínima',
    createMinVersion: 'Crear versión mínima',
    minVersionDescription: 'Descripción',
    minVersionDescriptionPlaceholder: 'Descripción de la configuración de versión mínima',
    settingsTitle: 'Configuración',
    enterEmailPlaceholder: 'Ingresa el correo electrónico',
    // Sprint 28, story-142. settings/warehouse.
    warehouseBreadcrumb: 'Almacén',
    categoriesBreadcrumb: 'Categorías',
    materialEquipmentCategories: 'Categorías de materiales y equipo',
    addCategory: 'Agregar categoría',
    organizationCategories: 'Categorías de la organización',
    organizationCategoriesHint:
      'Estas categorías son específicas de tu organización. Puedes personalizarlas según tu flujo de trabajo.',
    materialCategoriesTab: 'Categorías de materiales ({n})',
    equipmentCategoriesTab: 'Categorías de equipo ({n})',
    searchCategoriesPlaceholder: 'Buscar categorías...',
    materialAndEquipment: 'Materiales y equipo',
    totalCategories: 'Total de categorías',
    deleteCategory: 'Eliminar categoría',
    confirmDeleteCategory:
      '¿Estás seguro de que deseas eliminar "{name}"? Esta acción no se puede deshacer.',
    categoryUpdated: 'Categoría actualizada correctamente',
    categoryCreated: 'Categoría creada correctamente',
    categorySaveError: 'Error al guardar la categoría',
    categoryDeleted: 'Categoría eliminada correctamente',
    categoryDeleteError: 'Error al eliminar la categoría',
  },
  common: {
    // Sprint 40, story-215. Panel de error de la lista de planes.
    retry: 'Reintentar',
    couldNotLoadSubscriptionPlans: 'No se pudieron cargar los planes de suscripción',
    // Sprint 31, story-160. Progreso del asistente de proyectos.
    wizardStepOf: 'Paso {n} de {total}',
    createdSuccessfully: 'Creado correctamente',
    updatedSuccessfully: 'Actualizado correctamente',
    deletedSuccessfully: 'Eliminado correctamente',
    // Sprint 29 (Addendum 11 fix) — see en.ts for the defect this closes.
    taskApprovedSuccessfully: 'Tarea aprobada correctamente',
    taskRejectedSuccessfully: 'Tarea rechazada correctamente',
    unknown: 'Desconocido',
    action: 'Acción',
    actions: 'Acciones',
    active: 'Activo',
    add: 'Agregar',
    alert: 'Alerta',
    all: 'Todos',
    back: 'Atrás',
    cancel: 'Cancelar',
    cannotDelete: 'No se puede eliminar si hay entidades relacionadas',
    clickDelete: 'Haz clic aquí para eliminar',
    clickEdit: 'Haz clic aquí para editar',
    clickShowDoc: 'Haz clic para mostrar en Google Docs',
    clickView: 'Haz clic aquí para ver',
    close: 'Cerrar',
    collapse: 'Contraer',
    color: 'Color',
    confirm: 'Confirmar',
    create: 'Crear',
    custom: 'Personalizado',
    delete: 'Eliminar',
    deleted: 'Eliminado',
    description: 'Descripción',
    disable: 'Deshabilitar',
    disabled: 'Deshabilitado',
    documents: 'Documentos',
    edit: 'Editar',
    saveChanges: 'Guardar cambios',
    email: 'Correo electrónico',
    enable: 'Habilitar',
    end: 'Fin',
    expand: 'Expandir',
    export: 'Exportar',
    import: 'Importar',
    name: 'Nombre',
    none: 'Ninguno',
    notNow: 'Ahora no',
    openDrawer: 'Abrir panel',
    optional: 'Opcional',
    options: 'Opciones',
    organization: 'Organización',
    owner: 'Propietario',
    preview: 'Vista previa',
    requestError: 'Error de solicitud de red',
    somethingWentWrong: 'Algo salió mal, actualiza la página e inténtalo de nuevo.',
    save: 'Guardar',
    show: 'Mostrar',
    step: 'Paso',
    submit: 'Enviar',
    triggers: 'Disparadores',
    update: 'Actualizar',
    user: 'Usuario',
    yes: 'Sí',
    first: 'Primero',
    second: 'Segundo',
    third: 'Tercero',
    fourth: 'Cuarto',
    last: 'Último',
    // Sprint 28, story-142.
    status: 'Estado',
    search: 'Buscar',
    filter: 'Filtrar',
    loading: 'Cargando...',
    previous: 'Anterior',
    next: 'Siguiente',
    showingResults: 'Mostrando {page} a {take} de {total} resultados',
    paginationLabel: 'Paginación',
    noResults: 'No hay datos disponibles',
    confirmActionTitle: 'Confirmar acción',
    confirmActionDescription: '¿Estás seguro de que deseas continuar con esta acción?',
    rows: 'Filas',
    showingRange: 'Mostrando {from}–{to} de {total}',
    previousPage: 'Página anterior',
    nextPage: 'Página siguiente',
    pageNumber: 'Página {n}',
    trialEndedReadOnly: 'Prueba terminada: solo lectura',
    goToBillingAddPaymentMethod: 'Ve a Facturación para agregar un método de pago',
    inactive: 'Inactivo',
    quantity: 'Cantidad',
    category: 'Categoría',
  },
  organizations: {
    title: 'Organizaciones',
    organization: 'Organización',
    ownersNames: 'Nombres de propietarios',
    ownersEmails: 'Correos de propietarios',
    addOrganization: 'Agregar organización',
    create: 'Crear',
    enableOrganization: 'Habilitar organización',
    disableOrganization: 'Deshabilitar organización',
    confirmDisableMessage:
      '¿Estás seguro de que deseas deshabilitar la organización?',
    confirmEnableMessage:
      '¿Estás seguro de que deseas habilitar la organización?',
    subscriptionColumn: 'Suscripción',
    billingColumn: 'Facturación',
    subscriptionFilterAll: 'Todas las suscripciones',
    subscriptionFilterLabel: 'Suscripción',
    stateEnabled: 'Habilitada',
    stateSuspended: 'Suspendida',
    stateDisabled: 'Deshabilitada',
    noSubscription: 'Sin suscripción',
    trialEndsLine: 'Termina el {date} (faltan {n} días)',
    trialEndsLineOneDay: 'Termina el {date} (falta 1 día)',
    trialEndsLineToday: 'Termina el {date} (termina hoy)',
    trialExpiredLine: 'Venció el {date}',
    billingNmi: 'Facturación NMI',
    billingFreeAdmin: 'Gratis (admin)',
    billingCardNotStarted: 'Tarjeta guardada, sin iniciar',
    billingNoCard: 'Sin tarjeta',
    billingNmiTooltip:
      'NMI controla el ciclo de facturación de esta organización',
    billingFreeAdminTooltip:
      'Activa sin suscripción NMI: nunca se le cobrará',
    billingCardNotStartedTooltip:
      'Hay una tarjeta guardada pero no se inició una suscripción NMI',
    billingNoCardTooltip: 'Sin método de pago guardado',
    extendFreePeriod: 'Extender período gratuito',
    noOrganizationsMatchOnPage:
      'Ninguna organización de esta página coincide con el filtro de suscripción.',
    noOrganizationsMatch:
      'Ninguna organización coincide con los filtros actuales.',
    clearFilters: 'Borrar filtros',
    currentStatus: 'Estado actual',
    extendDateLabel: 'Nueva fecha de fin del período gratuito',
    extendHelper:
      'El acceso se restablece de inmediato y termina en esta fecha, salvo que la organización inicie la facturación de pago.',
    extendInfo:
      'Esto no contacta a NMI ni cambia el estado Habilitada/Deshabilitada de la organización.',
    extendFreeAdminNote:
      'Gratis (admin): hoy no tiene fecha de fin. Al extender pasa a un período gratuito con fecha límite.',
    extendNmiReason:
      'La facturación de esta organización la gestiona NMI, por lo que su período gratuito no se puede extender aquí.',
    extendInvalidDate: 'Elige una fecha posterior a hoy.',
    assignNoteNmi:
      'Esta organización se factura a través de NMI. Asignar un plan aquí solo cambia el plan en nuestro sistema; NMI sigue cobrando el precio del plan anterior, por lo que ambos pueden desalinearse. Cambia también el plan en NMI.',
    assignNoteTrialExpired:
      'Asignar un plan no restablece el acceso. Usa Extender período gratuito para darle más tiempo a esta organización.',
    assignNoteDefault:
      'Nota: Esta es una asignación administrativa y NO generará cargos ni afectará la facturación en el sistema de pagos.',
    assignPlanTitle: 'Asignar plan',
    assignConfirm: 'Asignar',
    currentPlan: 'Plan actual:',
    selectPlanLabel: 'Seleccionar plan',
    selectPlanPlaceholder: 'Selecciona un plan...',
    billingPeriodLabel: 'Período de facturación',
    billingPeriodMonthly: 'Mensual',
    billingPeriodAnnual: 'Anual',
    planDetails: 'Detalles del plan',
    planPrice: 'Precio: {price}/mes',
    planIncludedSeats: 'Asientos incluidos: {n}',
    planAnnualTotal: 'Total anual: {total}/año',
    searchPlaceholder: 'Buscar organizaciones...',
    pauseInvoicing: 'Pausar facturación',
    resumeInvoicing: 'Reanudar facturación',
    clearSelection: 'Limpiar',
    selectAllOnPage: 'Seleccionar todas las organizaciones de esta página',
    owners: 'Propietarios',
    subcontractor: 'Subcontratista',
    atav: 'ATAV',
    plan: 'Plan',
    state: 'Estado',
    noOwners: 'Sin propietarios',
    showAsSubcontractor: 'Mostrar como subcontratista',
    atavEnabled: 'Captura de campo ATAV habilitada',
    assignPlan: 'Asignar plan',
    invoicingPaused: 'Facturación en pausa',
    editOrganization: 'Editar organización',
    disableOrganizationAction: 'Deshabilitar organización',
    enableOrganizationAction: 'Habilitar organización',
    pageRange: '{range} de {count}',
    pauseInvoicingTitle: 'Pausar facturación',
    resumeInvoicingTitle: 'Reanudar facturación',
    pause: 'Pausar',
    resume: 'Reanudar',
    enableOrganizationsTitle: 'Habilitar organizaciones',
    disableOrganizationsTitle: 'Deshabilitar organizaciones',
    enableAll: 'Habilitar todas',
    disableAll: 'Deshabilitar todas',
    userInformation: 'Información del usuario',
  },
  users: {
    title: 'Usuarios',
    role: 'Rol',
    firstName: 'Nombre',
    status: 'Estado',
    lastName: 'Apellido',
    addUser: 'Agregar usuario',
    disableUser: 'Deshabilitar usuario',
    editUser: 'Editar usuario',
    confirmDisableMessage: '¿Estás seguro de que deseas deshabilitar el usuario?',
    confirmEnableMessage: '¿Estás seguro de que deseas habilitar el usuario?',
    notAllowedToEdit: 'No tienes permiso para editar este usuario',
    locale: 'Idioma',
  },
  clients: {
    client: 'Cliente',
    addClient: 'Agregar nuevo cliente',
    name: 'Nombre',
    address: 'Dirección',
    phone: 'Teléfono',
    email: 'Correo electrónico',
    phoneErrorMessage: 'Formato de teléfono inválido',
    emailErrorMessage: 'Formato de correo electrónico inválido',
    addressErrorMessage: 'La dirección debe tener al menos 3 caracteres',
    nameErrorMessage: 'El nombre debe tener al menos 3 caracteres',
    // Sprint 25, story-128 (run 5).
    // Sprint 47, story-235.
    emailInviteNotice:
      'Enviaremos una invitación a {email} al guardar. Se unirá a ZenHammer como Cliente: acceso de solo lectura a los proyectos de este cliente.',
    emailInviteNoticeReplace:
      'Al guardar se invitará a {email} como acceso de este cliente. El acceso anterior de este cliente será reemplazado.',
    createdInvited: 'Cliente creado. Invitación enviada a {email}.',
    createdLinked:
      'Cliente creado. {email} ya tiene acceso a ZenHammer y ahora puede ver estos proyectos como cliente.',
    emailAlreadyMember:
      '{email} ya es miembro de tu organización con otro rol. Usa otro correo o agrégalo como Revisor en el proyecto.',
    emailAlreadyClientUser:
      '{email} ya es el usuario cliente de otro cliente en tu organización. Un acceso por cliente: agrégalo como Revisor en su lugar.',
    accessTab: 'Acceso del cliente',
    // Sprint 52, story-269. División de los proyectos del cliente en activos y pasados.
    activeProjectsTab: 'Proyectos activos',
    pastProjectsTab: 'Proyectos anteriores',
    noActiveProjectsYet: 'Aún no hay proyectos activos',
    noPastProjectsYet: 'No hay proyectos anteriores',
    loginStatus: 'Acceso del cliente',
    loginStatusInvited: 'Invitado · aún no ha iniciado sesión',
    loginStatusActive: 'Activo · último acceso {date}',
    loginStatusNone: 'Sin acceso de cliente: agrega un correo para invitar',
    invite: 'Invitar',
    resendInvite: 'Reenviar invitación',
    inviteResent: 'Invitación reenviada.',
    removeAccess: 'Quitar acceso',
    replaceLoginTitle: '¿Reemplazar el acceso del cliente?',
    replaceLoginBody: '{email} tiene acceso de cliente actualmente. Elige qué hacer.',
    keepCurrentLogin: 'Mantener el acceso actual',
    replaceLogin: 'Reemplazar acceso',
    removeLoginTitle: '¿Quitar el acceso del cliente?',
    removeLoginBody: '{email} perderá el acceso a estos proyectos. El registro del cliente se conserva.',
    whatClientCanSee: 'Qué puede ver este cliente',
    alwaysVisible:
      'Siempre visible: nombre del proyecto, estado, fechas, dirección, descripción y el resumen de avance (porcentaje completado, estado de salud, tareas atrasadas y próximas, cantidad de incidentes abiertos).',
    defaultsNote:
      'Las tareas, las fechas del cronograma, el feed de actividad y los incidentes vienen activados de forma predeterminada; todo lo demás permanece desactivado hasta que lo actives.',
    'item.tasks': 'Tareas y su estado',
    'item.scheduleDates': 'Fechas del cronograma (inicio/fin de tareas)',
    'item.documents': 'Documentos',
    'item.evidence': 'Fotos de evidencia',
    'item.notes': 'Notas',
    'item.activity': 'Actividad',
    'item.incidents': 'Incidentes',
    'item.materials': 'Materiales: nombres y cantidades, nunca el costo',
    'item.equipment': 'Equipo: nombres y horas, nunca la tarifa',
    'item.priceTotals': 'Totales de precio (lo que cobras a este cliente)',
    accessUpdated: 'Acceso del cliente actualizado',
    dependencyTasksOn: 'También se activaron las tareas: las fechas viven en las tareas.',
    dependencyTasksOff: 'Al desactivar Tareas también se desactivaron sus elementos dependientes.',
    managerOnlyNote: 'Solo Propietario, Administrador y Gerente de Proyecto pueden cambiar el acceso del cliente.',
    groupWork: 'Trabajo',
    groupFiles: 'Archivos',
    groupCommunication: 'Comunicación',
    groupResources: 'Recursos',
    groupMoney: 'Dinero',
  },
  // Sprint 31, story-160/161. Asistente de creación de proyectos + generación de planes con IA.
  projectWizard: {
    title: 'Nuevo proyecto',
    stepBasics: 'Datos básicos',
    stepSchedule: 'Cronograma y ubicación',
    stepTeam: 'Equipo y cliente',
    stepBudget: 'Presupuesto',
    stepPlan: 'Planificación',
    planQuestion: '¿Cómo quieres configurar el plan de este proyecto?',
    planOptionManualTitle: 'Configurar manualmente',
    planOptionManualBody: 'Empieza con un cronograma vacío y agrega tareas tú mismo.',
    planOptionTemplateTitle: 'Crear desde plantilla',
    planOptionTemplateBody: 'Importa las tareas de una plantilla guardada a este proyecto.',
    planOptionAiTitle: 'Generar con IA',
    planOptionAiBody: 'Describe el trabajo o agrega archivos — la IA redacta tu plan.',
    backToOptions: '← Volver a las opciones',
    chooseTemplate: 'Elegir plantilla',
    createProject: 'Crear proyecto',
    next: 'Siguiente',
    previous: 'Anterior',
    discardTitle: '¿Descartar este proyecto?',
    discardBody: 'Perderás todo lo que ingresaste en este formulario.',
    discardConfirm: 'Descartar',
    discardCancel: 'Seguir editando',
  },
  aiPlan: {
    briefTitle: 'Describe el trabajo',
    briefPlaceholder:
      'Ej. "Renovación de un triplex, panel eléctrico nuevo, 2 baños, terminar antes de fin de trimestre."',
    attachmentsLabel: 'Adjunta fotos, planos o una lista de materiales (opcional)',
    dropZoneHint: 'Suelta archivos aquí o haz clic para buscar',
    dropZoneTypes: 'Imágenes, PDF, CSV, XLSX · hasta 10 archivos',
    fileCountOne: '{n} de 10 archivo',
    fileCountOther: '{n} de 10 archivos',
    generateSubmit: 'Generar plan →',
    generatingTitle: 'Generando tu plan…',
    generatingBody:
      'Esto suele tardar menos de un minuto. Puedes esperar aquí — la página se actualizará automáticamente cuando esté listo.',
    summaryTitle: 'Resumen',
    assumptionsTitle: 'Suposiciones',
    chatPlaceholder: 'Escribe un mensaje',
    chatSend: 'Enviar',
    chatYouLabel: 'Tú',
    chatAiLabel: 'IA',
    commitCreateProject: 'Crear proyecto con este plan →',
    commitImportProject: 'Importar al proyecto →',
    commitSaveTemplate: 'Guardar como plantilla',
    commitCancel: 'Cancelar',
    adjustEndDates: 'Ajustar la fecha de fin del proyecto a este plan',
    failedTitle: 'Algo salió mal al generar esta revisión.',
    retry: 'Reintentar',
    saveTemplateNameLabel: 'Nombre de la plantilla',
    saveTemplateSuccess: 'Guardado como plantilla',
    leaveTitle: '¿Salir sin guardar?',
    leaveBody: 'Perderás este plan sin guardar.',
    leaveConfirm: 'Salir',
    leaveCancel: 'Seguir revisando',
    progressPreparing: 'Preparando el contexto del proyecto',
    progressReading: 'Leyendo archivos adjuntos ({i} de {n})',
    progressReadingPending: 'Lectura de archivos adjuntos',
    progressReadDone: 'Se leyeron {n} archivos adjuntos',
    progressReadDoneOne: 'Se leyó 1 archivo adjunto',
    progressPlanning: 'Planificando las fases',
    progressPlannedPhases: 'Se planificaron {n} fases',
    progressPlannedPhasesOne: 'Se planificó 1 fase',
    progressDrafting: 'Redactando la fase {k}',
    progressDraftingOf: 'Redactando la fase {k} de {n}',
    progressDraftingPending: 'Redactando las fases',
    progressDraftedPhases: 'Se redactaron {n} fases',
    progressDraftedPhasesOne: 'Se redactó 1 fase',
    progressValidating: 'Validando y guardando',
    progressStarting: 'Iniciando...',
    progressLeaveHint: 'Puedes salir de esta página; tu plan sigue generándose.',
    progressSlow: 'Sigue en proceso; los planes grandes pueden tardar más.',
    errUnavailableTitle: 'La planificación con IA no está disponible',
    errUnavailableBody: 'La planificación con IA no está disponible temporalmente. Se ha notificado a tus administradores.',
    errBusyTitle: 'La planificación con IA está ocupada',
    errBusyBody: 'La planificación con IA tiene mucha demanda ahora. Inténtalo de nuevo en un minuto.',
    errGenericTitle: 'No se pudo generar el plan',
    errGenericBody: 'Ocurrió un problema al generar el plan. Inténtalo de nuevo.',
    changeRemoved: 'Eliminado: {names}',
    changeRemovedMore: '{names} y {n} más',
    panelTitle: 'Planes con IA en curso',
    resumeLink: 'Retomar un plan con IA ({n})',
    resumeEmpty: 'No hay planes con IA en curso.',
    statusReady: 'Listo para revisar',
    openDraft: 'Abrir',
    untitledDraft: 'Plan con IA sin título',
    inProgressTitle: 'Tienes {n} planes con IA en curso',
    inProgressTitleOne: 'Tienes 1 plan con IA en curso',
    resumeDraft: 'Retomar',
    chatWorking: 'Aplicando tus cambios...',
    draftNewProject: 'Proyecto nuevo',
    draftTemplate: 'Plantilla',
    draftExistingProject: 'Proyecto existente',
    draftsLoadError: 'No se pudieron cargar tus planes con IA',
    draftGone: 'Este plan con IA ya no está disponible',
    draftGoneAction: 'Empezar de nuevo',
    resumeFillDetails: 'Tu plan está listo. Completa primero los datos del proyecto y luego crea el proyecto.',
    discardDraft: 'Descartar',
    cancelDraft: 'Cancelar',
    discardConfirmGenerating: '¿Detener la generación y descartar este plan?',
    discardConfirmReady: '¿Descartar este plan?',
    discardConfirmYes: 'Sí, descartar',
    discardConfirmNo: 'Conservar',
    draftDiscarded: 'Plan con IA descartado',
    draftDiscardFailed: 'No se pudo descartar el plan con IA',
  },
  taskTree: {
    dayOne: '{n} día',
    dayOther: '{n} días',
    materialOne: 'Material: {n}',
    materialOther: '{n} materiales',
    equipmentOne: '{n} equipo',
    equipmentOther: '{n} equipos',
    addSubtask: '+ Subtarea',
    removeTask: 'Quitar tarea',
    catalogChip: 'catálogo',
    manualChip: 'Manual',
    editName: 'Editar nombre',
    editDuration: 'Editar duración (días)',
    editStart: 'Editar día de inicio',
    dayN: 'Día {n}',
    deleteTask: 'Eliminar tarea',
    deletePhase: 'Eliminar fase',
    deleteConfirmTask: '¿Eliminar "{name}"?',
    deleteConfirmPhase: '¿Eliminar "{name}" y sus {n} tareas?',
    save: 'Guardar',
    cancel: 'Cancelar',
    saving: 'Guardando...',
    saveError: 'No se pudo guardar el cambio. Inténtalo de nuevo.',
    errNameRequired: 'El nombre es obligatorio.',
    errDuration: 'La duración debe ser un número entero de al menos 1 día.',
    errStart: 'El día de inicio debe ser un número entero, 0 o más.',
    errNumber: 'Ingresa un número.',
    noTasks: 'Sin tareas',
  },
  templatesPage: {
    generateWithAi: 'Generar con IA',
  },
  projects: {
    project: 'Proyecto',
    addProject: 'Agregar nuevo proyecto',
    name: 'Nombre del proyecto',
    address: 'Dirección',
    nameErrorMessage: 'El nombre debe tener al menos 3 caracteres',
    addressErrorMessage: 'La dirección debe tener al menos 3 caracteres',
    startErrorMessage: 'Ingresa una fecha válida en el formato MM/DD/AAAA',
    endErrorMessage: 'Ingresa una fecha válida en el formato MM/DD/AAAA',
    rangeErrorMessage: 'La fecha de fin no puede ser anterior a la fecha de inicio',
    budgetErrorMessage: 'Ingresa un número mayor que 0',
    // Sprint 25, story-128 (D8).
    descriptionClientVisibleNote:
      'Esta descripción también es visible para el cliente del proyecto.',
    // Sprint 25, story-129.
    sectionYours: 'Tus proyectos',
    sectionDelegated: 'Delegados a ti ({n})',
    delegatedBanner:
      'Delegado por {org} · su proyecto "{project}". Aquí gestionas cuadrillas, materiales, equipo y tiempo; {org} sigue el avance desde su lado.',
    badgeDelegated: 'Delegado',
    selfMirrorLink: 'Tu organización: copia delegada',
    statusOngoing: 'En curso',
    statusCompleted: 'Completado',
    statusAbandoned: 'Abandonado',
    statusDelayed: 'Demorado',
    statusBidding: 'En licitación',
    statusDraft: 'Borrador',
    statusBehind: 'Atrasado',
    allStates: 'Todos los estados',
    newProject: 'Nuevo proyecto',
    noProjectsYet: 'Aún no hay proyectos',
    tabProjectFeed: 'Actividad del proyecto',
    tabDocuments: 'Documentos',
    tabEvidence: 'Evidencia',
    // Sprint 43, story-224. Pestañas del proyecto para el CLIENTE (según la lista de acceso). Reintentar reutiliza `common.retry`.
    tabTasks: 'Tareas',
    tabIncidents: 'Incidentes',
    clientTasksColTask: 'Tarea',
    clientTasksColStatus: 'Estado',
    clientTasksColType: 'Tipo',
    clientTasksColStart: 'Inicio',
    clientTasksColEnd: 'Fin',
    clientTasksEmpty: 'Aún no hay tareas para mostrar.',
    clientIncidentsEmpty: 'No hay incidentes reportados en este proyecto.',
    clientTabLoadError: 'No pudimos cargar esta sección. Inténtalo de nuevo.',
    clientAccessLoadError: 'No pudimos cargar tu proyecto. Inténtalo de nuevo.',
    tabVisitors: 'Visitantes',
    visitorsNowLabel: 'Ahora',
    tabInvoices: 'Facturas',
    deleteProjectTitle: 'Eliminar proyecto',
    confirmDeleteProject: '¿Estás seguro de que deseas eliminar este proyecto?',
    projectFallbackName: 'Proyecto',
    // Sprint 31, story-156.
    editProjectModalTitle: 'Editar proyecto',
    addProjectModalTitle: 'Agregar proyecto',
    updateProjectButton: 'Actualizar proyecto',
    siteImageDropTitle: 'Suelta la imagen del sitio aquí, o haz clic para seleccionar',
    siteImageDropSubtitle: 'PNG, JPG, GIF de hasta 50 MB',
    namePlaceholder: 'Ingresa el nombre del proyecto',
    stateLabel: 'Estado',
    statePlaceholder: 'Ingresa el estado del proyecto',
    descriptionLabel: 'Descripción',
    descriptionPlaceholder: 'Ingresa una descripción del proyecto',
    startDateLabel: 'Fecha de inicio',
    startDatePlaceholder: 'Ingresa la fecha de inicio del proyecto',
    endDateLabel: 'Fecha de finalización',
    endDatePlaceholder: 'Ingresa la fecha de finalización del proyecto',
    addressPlaceholder: 'Ingresa la dirección del proyecto',
    projectManagerLabel: 'Gerente de proyecto',
    projectManagerPlaceholder: 'Selecciona un gerente de proyecto',
    superintendentsLabel: 'Superintendentes',
    superintendentsPlaceholder: 'Selecciona superintendentes',
    reviewersLabel: 'Revisores',
    reviewersPlaceholder: 'Selecciona revisores',
    clientLabel: 'Cliente',
    clientPlaceholder: 'Selecciona un cliente',
    budgetLabel: 'Presupuesto',
    budgetPlaceholder: 'Ingresa el presupuesto del proyecto',
    totalManHoursLabel: 'Total de horas-hombre',
    totalManHoursPlaceholder: 'Ingresa el total de horas-hombre',
    createFromTemplateButton: 'Crear desde plantilla',
    selectTemplateModalTitle: 'Selecciona una plantilla',
    createWithTemplateButton: 'Crear con plantilla',
    pendingInvoiceItemsTitle: 'Elementos pendientes de facturar',
    completeAnywayButton: 'Completar de todos modos',
    invoicePendingMaterialOne: 'un material',
    invoicePendingMaterialOther: '{n} materiales',
    invoicePendingEquipmentOne: '{n} artículo de equipo',
    invoicePendingEquipmentOther: '{n} artículos de equipo',
    invoicePendingTaskOne: '1 tarea',
    invoicePendingTaskOther: '{n} tareas',
    invoicePendingJoiner: ' y ',
    invoicePendingDescription:
      'Este proyecto tiene {items} en {taskLabel} sin facturar{sample}. Si completas el proyecto ahora, estos se marcarán como elementos pendientes de facturar. ¿Completar de todos modos?',
    invoicePendingSampleSuffix: ' (p. ej., {names})',
    submitFailedFallback: 'No se pudo crear el proyecto. Inténtalo de nuevo.',
    unknownEmployeeFallback: 'Empleado desconocido',
    unknownReviewerFallback: 'Revisor desconocido',
    nameRequiredError: 'El nombre del proyecto es obligatorio',
    budgetPositiveError: 'El presupuesto debe ser un número positivo',
    totalManHoursPositiveError: 'El total de horas-hombre debe ser un número positivo',
    startDateRequiredError: 'La fecha de inicio es obligatoria',
    endDateRequiredError: 'La fecha de finalización es obligatoria',
    stateRequiredError: 'El estado es obligatorio',
  },
  incidents: {
    documentCountOne: '{n} archivo',
    documentCountOther: '{n} archivos',
    reportIncident: 'Reportar Incidente',
    modalTitle: 'Reportar Incidente',
    project: 'Proyecto',
    selectProject: 'Seleccionar un proyecto...',
    selectProjectFirst: 'Seleccione un proyecto primero',
    name: 'Nombre del Incidente',
    namePlaceholder: 'Ingrese el nombre del incidente',
    time: 'Hora del Incidente',
    type: 'Tipo de Incidente',
    selectType: 'Seleccionar tipo...',
    typeWeather: 'Clima',
    typeAccident: 'Accidente',
    typeMaterialsIssue: 'Problema de Materiales',
    typeEquipmentIssue: 'Problema de Equipo',
    typeOther: 'Otro',
    otherType: 'Otro Tipo',
    otherTypePlaceholder: 'Ingrese el tipo de incidente',
    delay: 'Retraso',
    delayUnit: 'Unidad de Retraso',
    selectUnit: 'Seleccionar unidad...',
    unitHours: 'Horas',
    unitDays: 'Días',
    unitWeeks: 'Semanas',
    description: 'Descripción',
    descriptionPlaceholder: 'Describa el incidente...',
    affectedTasks: 'Tareas Afectadas (opcional)',
    affectedTasksPlaceholder: 'Buscar y seleccionar tareas...',
    attachments: 'Archivos Adjuntos (opcional)',
    cancel: 'Cancelar',
    submit: 'Reportar Incidente',
    submitting: 'Reportando...',
    projectRequired: 'El proyecto es obligatorio',
    nameRequired: 'El nombre del incidente es obligatorio',
    timeRequired: 'La hora del incidente es obligatoria',
    typeRequired: 'El tipo de incidente es obligatorio',
    otherTypeRequired: 'Por favor especifique el tipo de incidente',
    delayRequired: 'El retraso es obligatorio',
    delayMustBeNumber: 'El retraso debe ser un número',
    delayMustBePositive: 'El retraso debe ser positivo',
    delayUnitRequired: 'La unidad de retraso es obligatoria',
    descriptionRequired: 'La descripción es obligatoria',
    success: 'Incidente reportado exitosamente',
    error: 'Error al reportar el incidente',
  },
  // Sprint 25, story-134.
  subcontractors: {
    since: 'Desde {date}',
    projectsCount: '{n} de mis proyectos',
    tasksBreakdown: '{n} tareas ({active} activas · {complete} completas · {cancelled} canceladas)',
    agreedPrice: 'Precio acordado',
    notSet: 'Sin definir',
    withoutPrice: '{n} tareas sin precio',
    healthOnTrack: 'En tiempo',
    healthBehind: 'Atrasado',
    healthNotStarted: 'Sin iniciar',
    healthComplete: 'Todo completo',
    healthNone: 'Nada delegado',
    complete: '{pct}% completo',
    overdue: '{n} atrasadas',
    avgDaysLate: 'prom. {d} d de retraso ({n})',
    earned: 'Ganado a la fecha',
    ofAgreed: '{pct}% del acordado',
    atRisk: 'En riesgo',
    onOverdue: 'en tareas atrasadas',
    tabOverview: 'Resumen',
    tabWork: 'Trabajo',
    tabBids: 'Licitaciones',
    tabActivity: 'Actividad',
    needsAttention: 'Requiere atención',
    allClear: 'Todo en orden',
    awaitingApproval: 'Pendiente de mi aprobación ({n})',
    openIncidents: 'Incidentes abiertos en su trabajo ({n})',
    overdueGroup: 'Atrasadas ({n})',
    progressByProject: 'Avance por proyecto',
    dueThisWeek: '{n} vencen esta semana',
    spendVsAgreed: 'Gasto vs acordado',
    colAgreed: 'Acordado',
    colEarned: 'Ganado',
    colRemaining: 'Restante',
    colAtRisk: 'En riesgo',
    earnedNote: 'Ganado = precio acordado de las tareas completas. No vinculado a facturas.',
    materialsEquipment: 'Materiales y equipo en trabajo delegado',
    rollup: '{m} materiales · {e} equipos · lado precio cliente {amount}',
    colTask: 'Tarea',
    colStatus: 'Estado',
    colStart: 'Inicio',
    colEnd: 'Fin',
    colLateLeft: 'Retraso/restante',
    colOrigin: 'Origen',
    daysLate: '{d} d de retraso',
    daysLeft: '{d} d restantes',
    doneOn: 'hecho {date}',
    originBid: 'Licitación · {amount}',
    originDirect: 'Directa',
    cancelledGroup: '{n} canceladas',
    inventoryLine: '{m} materiales · {e} equipos',
    costHiddenNote: 'Costo del subcontratista oculto: solo nombres, cantidades y lado precio cliente',
    winRate: 'Tasa de éxito {pct}% ({won} de {closed} cerradas)',
    avgVsCeiling: 'Aceptadas prom. {pct}% del tope',
    openBids: '{n} abiertas',
    colSent: 'Enviada',
    colProjectTask: 'Proyecto · Tarea',
    colCeiling: 'Mi tope',
    colTheirBid: 'Su oferta',
    colOutcome: 'Resultado',
    outcomeAccepted: 'Aceptada',
    outcomeDeclined: 'Rechazada',
    outcomeCountered: 'Contraoferta',
    outcomeOpen: 'Abierta',
    outcomeCancelled: 'Cancelada',
    emptyDelegated: 'Aún no hay nada delegado.',
    emptyDelegatedHint: 'Envía a {sub} una solicitud de licitación o delega una tarea desde un proyecto.',
    emptyBids: 'Aún no hay licitaciones con {sub}.',
    noPricesYet: 'Aún no hay precios acordados',
    rosterAllClear: 'Todo en orden · {n} activas',
    rosterLine: '{overdue} atrasadas · {approvals} aprobación(es) · {incidents} incidente(s)',
  },
  schedule: {
    // Sprint 38, story-209. Project/Month timeline range switch in the schedule toolbar.
    viewProject: 'Proyecto',
    viewMonth: 'Mes',
    viewMonthTooltip: 'Cronograma mensual',
    viewRangeLabel: 'Rango del cronograma',
    // Sprint 31, story-161. Punto de entrada "Generar con IA" en el acordeón, junto a Importar plantilla.
    generateWithAi: 'Generar con IA',
    // Sprint 25, story-133. Clima NOAA en el calendario del cronograma.
    weatherForecast: 'Pronóstico',
    weatherObserved: 'Observado',
    weatherObservedSoFar: 'Observado hasta ahora',
    weatherWorstWindow: 'lo peor entre {start} y {end}',
    weatherHigh: 'Máx.',
    weatherLow: 'Mín.',
    weatherPrecip: 'Precip.',
    weatherPrecipChance: '{pct}% precip.',
    weatherSource: 'Fuente: NOAA',
    weatherSourceStation: 'Fuente: NOAA · estación {station}',
    weatherLegend: 'Clima: contorno = pronóstico, relleno = observado (lo peor {start}–{end})',
    weatherNoLocation: 'Sin clima: agrega la ubicación del proyecto',
    weatherConditionThunderstorm: 'Tormentas',
    weatherConditionIce: 'Lluvia helada / hielo',
    weatherConditionSnow: 'Nieve',
    weatherConditionHeavyRain: 'Lluvia intensa',
    weatherConditionRain: 'Lluvia',
    weatherConditionDrizzle: 'Llovizna',
    weatherConditionFog: 'Niebla',
    weatherConditionWind: 'Viento',
    weatherConditionCloudy: 'Nublado',
    weatherConditionPartlyCloudy: 'Parcialmente nublado',
    weatherConditionClear: 'Despejado',
    // Sprint 34, story-133 CR. Timeline drag/resize feedback, previously hardcoded.
    invalidDateFormat: 'Formato de fecha no válido',
    taskAndSubtasksUpdated: 'Tarea y subtareas actualizadas correctamente',
    parentExtendedSubtaskUpdated: 'Tarea principal extendida y subtarea actualizada correctamente',
    updatingTask: 'Actualizando:',
  },
  // Sprint 28, story-144.
  dashboard: {
    noAccess: 'No tienes acceso a esta página',
    createProject: 'Crear proyecto',
    noProjectsYet: 'Aún no hay proyectos',
    activeProjects: 'Proyectos activos',
    recentActivity: 'Actividad reciente',
    noRecentActivity: 'Sin actividad reciente',
    allProjects: 'Todos los proyectos',
    refresh: 'Actualizar',
    filterByProject: 'Filtrar por proyecto',
    noActiveProjects: 'No hay proyectos activos',
    noActivitiesToDisplay: 'No hay actividades para mostrar',
    // Sprint 43, story-223. Inicio del CLIENTE (`/dashboard` para el rol CLIENT).
    clientViewBanner: 'Estás viendo los proyectos de {org} como cliente. Esta cuenta es solo de lectura.',
    clientViewBannerDismiss: 'Cerrar',
    clientYourProjects: 'Tus proyectos',
    clientNoProjects: 'Aún no hay proyectos: {org} no te ha agregado a ningún proyecto.',
    clientProjectDates: '{start} - {end}',
    clientProjectStarts: 'Inicia el {start}',
    clientProjectNoDates: 'Fechas por definir',
    clientOpenProject: 'Abrir proyecto {name}',
    clientLoadError: 'No pudimos cargar tus proyectos. Inténtalo de nuevo.',
    clientRetry: 'Reintentar',
    viewGeofence: 'Ver geocerca',
    triageAllLabel: 'Toda la actividad',
    triageIncidentsLabel: 'Incidentes',
    triageBidsLabel: 'Ofertas',
    triageInvoicesLabel: 'Facturas',
  },
  invoices: {
    tabAll: 'Todas',
    tabPending: 'Facturas pendientes',
    tabDrafts: 'Borradores',
    tabSent: 'Enviadas',
    tabPaid: 'Pagadas',
    tabVoided: 'Anuladas',
    tabErrors: 'Errores',
  },
  // Sprint 28, story-144 (AC2). Mirrors mobile's `taskDetail` section name exactly.
  taskDetail: {
    confirmChangeStatusTo: '¿Cambiar el estado de la tarea a "{status}"?',
    warningIrreversible: 'Este cambio se aplicará de inmediato y puede ser irreversible.',
    warningLabel: 'Advertencia:',
    completeWithIncompleteSubtasksTitle: 'Completar tarea con subtareas incompletas',
    warningIrreversibleContinue:
      'Este cambio se aplicará de inmediato y es irreversible. ¿Deseas continuar?',
    pendingInvoiceItemsTitle: 'Elementos pendientes de facturar',
    incompleteSubtaskOne: '{n} subtarea incompleta',
    incompleteSubtaskOther: '{n} subtareas incompletas',
    completeWithIncompleteSubtasksMessage:
      'Esta tarea tiene {subtasks}. Marcar esta tarea como completa no afectará el estado de esas subtareas.',
    materialUnbilledOne: '{n} material sin facturar',
    materialUnbilledOther: '{n} materiales sin facturar',
    equipmentUnbilledOne: '{n} equipo sin facturar',
    equipmentUnbilledOther: '{n} equipos sin facturar',
    taskInvoicePendingMessage:
      'Esta tarea todavía tiene {material} y {equipment}.\n\nTe recomendamos crear la factura antes de marcar la tarea como completa para que no se pierda nada.',
    pendingSamplesPrefix: '\n\nPendiente: ',
    completeAnywayButton: 'Completar de todos modos',
    reasonForRejection: 'Motivo del rechazo (opcional)',
    enterRejectionReason: 'Ingresa el motivo por el que rechazas esta tarea...',
    confirmChange: 'Confirmar cambio',
    updating: 'Actualizando...',
    confirmStatusChangeTitle: 'Confirmar cambio de estado',
    delegatedCannotChangeStatus:
      'Esta tarea fue delegada a otra organización. No puedes cambiar el estado hasta que envíen de vuelta su trabajo completado.',
    delegationBanner: 'Tarea delegada:',
    delegationBannerText: 'Esta tarea fue delegada por {org}',
    // Sprint 28, develop run 3 (story-144 review Critical #1 fix). Vocabulario canónico de
    // estado de la guía de estilo §5 — mismas claves que `taskDetail.status*` en mobile.
    statusActive: 'Activa',
    statusInactive: 'Inactiva',
    statusComplete: 'Completa',
    statusInternalApproval: 'Aprobación interna',
    statusClientApproval: 'Aprobación del cliente',
    statusRejected: 'Rechazada',
    statusCanceled: 'Cancelada',
    statusDelegationCanceled: 'Delegación cancelada',
    // Sprint 28 change request (global sweep, defect fix). Ver el comentario equivalente en en.ts.
    statusUnknown: 'Desconocido',
    displayUpcoming: 'Próxima',
    displayBehindSchedule: 'Atrasada',
    displayAssignedToSubcontractor: 'Asignada al subcontratista',
    displayAssignedToCrew: 'Asignada a la cuadrilla',
    displayInNegotiations: 'En negociación',
    displayUnassigned: 'Sin asignar',
    // Sprint 28, story-144 (residual gap). Subárbol BudgetTab de CreateEditTaskModal.
    budget: {
      subTabReceived: 'Oferta recibida',
      subTabDelegated: 'Oferta subdelegada',
      tabActive: 'Presupuesto activo',
      tabPast: 'Presupuestos anteriores',
      delegationInfoTitle: 'Información de delegación',
      delegatedTo: 'Delegado a',
      currentOrganization: 'Organización actual',
      originalAcceptedOrg: 'Organización original aceptada',
      notAvailable: 'N/D',
      noBidActivityTitle: 'Sin actividad de ofertas',
      delegationBidDetailsTitle: 'Detalles de la oferta de delegación',
      subDelegationBidDetailsTitle: 'Detalles de la oferta de subdelegación',
      noBidRequestFoundTitle: 'No se encontró solicitud de oferta',
      delegatedNoBidRequestMessage:
        'Esta tarea fue delegada a otra organización, pero no se encontraron datos de la solicitud de oferta.',
      taskDelegatedTo: 'Tarea delegada a:',
      unknownOrganization: 'Organización desconocida',
      noBudgetActivityTitle: 'Sin actividad de presupuesto',
      noBudgetActivityMessage: 'Esta tarea todavía no tiene solicitudes de oferta asociadas.',
      headerDelegatedBid: 'Oferta delegada',
      headerReceivedBidRequest: 'Solicitud de oferta recibida',
      headerSubDelegatedBid: 'Oferta subdelegada',
      headerBidRequest: 'Solicitud de oferta',
      statusCompletedCancelled: 'COMPLETADO (CANCELADO)',
      badgeReceived: 'RECIBIDA',
      badgeSent: 'ENVIADA',
      cancelledBadge: 'CANCELADO',
      pastDelegationBid: 'Oferta de delegación anterior',
      pastDelegationBids: 'Ofertas de delegación anteriores',
      cancelledSingleMessage: 'Esta solicitud de oferta era para una delegación que fue cancelada.',
      cancelledMultipleMessage:
        'Estas {n} solicitudes de oferta eran para delegaciones que fueron canceladas.',
      cancelledDelegationTo: 'Delegación cancelada a:',
      unknown: 'Desconocido',
      amount: 'Monto:',
      start: 'Inicio:',
      end: 'Fin:',
      accepted: 'Aceptado:',
      cancelled: 'Cancelado:',
      delegatedTaskId: 'ID de tarea delegada:',
      viewDetails: 'Ver detalles',
      notSpecified: 'No especificado',
      originalProject: 'Proyecto original',
      project: 'Proyecto',
      originalTask: 'Tarea original',
      task: 'Tarea',
      currentDelegatedTask: 'Tarea delegada actual',
      delegatedProject: 'Proyecto delegado',
      delegationRecipient: 'Destinatario de la delegación',
      budgetRecipients: 'Destinatarios del presupuesto',
      subDelegationRecipient: 'Destinatario de la subdelegación',
      budgetOriginator: 'Origen del presupuesto',
      originatorOrganization: 'Organización de origen',
      assignedOrganization: 'Organización asignada',
      status: 'Estado',
      // Sprint 28 change request (global sweep, defect fix). Ver el comentario equivalente en en.ts.
      recipientStatusSent: 'Enviada',
      recipientStatusViewed: 'Vista',
      recipientStatusResponded: 'Respondida',
      recipientStatusAccepted: 'Aceptada',
      recipientStatusRejected: 'Rechazada',
      delegationCreated: 'Delegación creada',
      subDelegationCreated: 'Subdelegación creada',
      taskCreatedFromAcceptedBid: 'Tarea creada a partir de oferta aceptada',
      yourStatus: 'Tu estado: {status}',
      bidAcceptedBy: 'Oferta aceptada por {org}',
      bidRequestPending: 'Solicitud de oferta pendiente',
      originalBidDetailsTitle: 'Detalles de la oferta original',
      bidDetailsTitle: 'Detalles de la oferta',
      amountLabel: 'Monto',
      startDateLabel: 'Fecha de inicio',
      endDateLabel: 'Fecha de fin',
      delegationDate: 'Fecha de delegación',
      subDelegationDate: 'Fecha de subdelegación',
      acceptedDate: 'Fecha de aceptación',
      description: 'Descripción',
      attachedDocuments: 'Documentos adjuntos',
      delegationLabel: 'Delegación',
      subDelegationLabel: 'Subdelegación',
      budgetRequestLabel: 'Solicitud de presupuesto',
      loadingBudgetInfo: 'Cargando información de presupuesto...',
      noBudgetRequestsYet: 'Esta tarea todavía no tiene solicitudes de presupuesto asociadas.',
      delegationBudgetNumber: 'Presupuesto de delegación n.º {n}',
      subDelegationBudgetNumber: 'Presupuesto de subdelegación n.º {n}',
      originalBudgetNumber: 'Presupuesto original n.º {n}',
      budgetNumber: 'Presupuesto n.º {n}',
      viewFullHistory: 'Ver historial completo',
    },
    // Sprint 28, story-144 (residual gap). Subárbol GeneralTab de CreateEditTaskModal.
    general: {
      statusLabel: 'Estado',
      selectStatus: 'Selecciona el estado',
      statusChangesAppliedImmediately: 'Los cambios de estado se aplican de inmediato',
      statusLocked: 'Estado bloqueado:',
      delegatedTaskLabel: 'Tarea delegada:',
      statusOptionsLimitedMessage:
        'Las opciones de estado están limitadas según el rol de tu organización en la cadena de delegación.',
      addSubtaskTitle: 'Agregar subtarea',
      selectTasksToAddLabel: 'Selecciona tareas para agregar como subtareas',
      chooseTasksPlaceholder: 'Elige tareas...',
      cancel: 'Cancelar',
      adding: 'Agregando...',
      addSubtaskButton: 'Agregar subtarea',
      addSubtasksButton: 'Agregar subtareas',
      subtasksTitle: 'Subtareas',
      createSubtask: 'Crear subtarea',
      importTemplate: 'Importar plantilla',
      infoLabel: 'Información:',
      delegatedNoSubtasksMessage: 'Esta tarea no puede tener subtareas porque está delegada.',
      pendingBudgetNoSubtasksMessage:
        'Esta tarea no puede tener subtareas mientras haya una solicitud de oferta pendiente de aprobación.',
      colName: 'Nombre',
      colStatus: 'Estado',
      colStartTime: 'Hora de inicio',
      colEndTime: 'Hora de fin',
      colTaskType: 'Tipo de tarea',
      colActions: 'Acciones',
      willBeAdded: 'Se agregará',
      pendingAdd: 'Adición pendiente',
      pendingRemove: 'Eliminación pendiente',
      remove: 'Eliminar',
      undoRemove: 'Deshacer eliminación',
      noSubtasksAssigned: 'Todavía no hay subtareas asignadas.',
      clickAddSubtasksHint:
        'Haz clic en "Agregar subtareas" para seleccionar tareas existentes como subtareas.',
      noAvailableTasksToAdd: 'No hay tareas disponibles para agregar como subtareas.',
    },
    // Sprint 28, story-144 (residual gap). CancelWarningModal, DocumentsTab.
    cancelWarningBudgetTitle: 'Cancelar solicitud de oferta',
    cancelWarningBudgetMessage:
      'Esto cancelará el proceso activo de solicitud de oferta. Todas las propuestas de oferta serán rechazadas y se notificará a las organizaciones destinatarias.',
    cancelWarningBudgetConsequence1: 'Se cancelará la solicitud de oferta activa',
    cancelWarningBudgetConsequence2: 'Se rechazarán todas las propuestas de oferta',
    cancelWarningBudgetConsequence3: 'Se notificará a las organizaciones destinatarias',
    cancelWarningBudgetConsequence4:
      'Luego podrás asignar la tarea a tu cuadrilla o crear una nueva solicitud de oferta',
    cancelWarningDelegationTitle: 'Cancelar delegación de tarea',
    cancelWarningDelegationMessage:
      'Esto cancelará la delegación de la tarea a {org}. La organización delegada perderá acceso a esta tarea.',
    cancelWarningDelegationDefaultOrg: 'el subcontratista',
    cancelWarningDelegationConsequence1: 'Se cancelará la delegación actual',
    cancelWarningDelegationConsequence2:
      'Se conservará todo el progreso de trabajo o los costos registrados por el subcontratista',
    cancelWarningDelegationConsequence3:
      'Luego podrás asignar la tarea a tu cuadrilla o delegarla a otra organización',
    cancelWarningCannotBeUndone: 'Esta acción no se puede deshacer',
    cancelWarningWhatWillHappen: 'Qué sucederá:',
    cancelWarningConfirmPrefix: '¿Seguro que deseas continuar?',
    cancelWarningWillImmediately: 'Esta acción va a',
    cancelWarningConfirmSuffixBudget: ' cancelar la solicitud de oferta',
    cancelWarningConfirmSuffixDelegation: ' cancelar la delegación',
    cancelWarningConfirmSuffix: 'y no se puede revertir.',
    keepCurrentAssignment: 'Mantener asignación actual',
    cancelBidRequestButton: 'Cancelar solicitud de oferta',
    cancelDelegationButton: 'Cancelar delegación',
    existingDocuments: 'Documentos existentes',
    addNewDocuments: 'Agregar nuevos documentos',
    documentsLabel: 'Documentos',
    dropDocumentsHere: 'Suelta los documentos aquí o haz clic para seleccionar',
    documentsSubtitle: 'PDF, TXT, CSV, imágenes de hasta 50MB cada una',
    // Sprint 28, story-144 (residual gap). SelectedCrewMembers, AssignmentTab.
    memberSingular: 'miembro',
    memberPlural: 'miembros',
    noMembersAssigned: 'No hay miembros asignados',
    unknownUser: 'Desconocido',
    // Sprint 28, story-144 (residual gap). InventoryItem y las pestañas de inventario/materiales/equipo.
    inventory: {
      qty: 'Cant.:',
      cost: 'Costo:',
      total: 'Total:',
      from: 'De:',
      returnToWarehouse: 'Devolver al almacén',
    },
    // Sprint 28, story-144 (residual gap). DateConflictModal.
    dateConflict: {
      title: 'Advertencia de conflicto de fechas',
      description:
        'Algunas subtareas tienen fechas que entran en conflicto con las fechas de la tarea principal. Las fechas de la tarea principal se ajustarán automáticamente para dar cabida a todas las subtareas.',
      mainTaskDateChanges: 'Cambios en las fechas de la tarea principal:',
      currentStart: 'Inicio actual:',
      currentEnd: 'Fin actual:',
      conflictingSubtasks: 'Subtareas en conflicto:',
      subtaskStartsConflict:
        'La subtarea comienza el {date}, que es antes de la fecha de inicio de la tarea principal ({mainDate})',
      subtaskEndsConflict:
        'La subtarea termina el {date}, que es después de la fecha de fin de la tarea principal ({mainDate})',
      note: 'Nota:',
      noteMessage:
        'Al continuar, las fechas de la tarea principal se ajustarán para que todas las subtareas queden dentro del cronograma de la tarea principal. Esta acción no se puede deshacer.',
      cancel: 'Cancelar',
      saving: 'Guardando...',
      continueAndAdjustDates: 'Continuar y ajustar fechas',
    },
    // Sprint 28, story-144 (residual gap). EquipmentSubTab.
    equipment: {
      title: 'Equipo de la tarea',
      itemSingular: 'artículo',
      itemPlural: 'artículos',
      inUseSuffix: '{n} en uso',
      reservedSuffix: '{n} reservado(s)',
      plannedSuffix: '{n} planificado(s)',
      returnedSuffix: '{n} devuelto(s)',
      manualSuffix: '{n} manual(es)',
      addManually: 'Agregar manualmente',
      reserve: 'Reservar',
      checkoutFromAssets: 'Retirar de activos',
      infoBanner:
        'Usa "Retirar de activos" para usar equipo rastreado, "Reservar" para apartarlo para uso futuro, o "Agregar manualmente" para equipo no rastreado. El equipo devuelto permanece visible en la lista.',
      loadingEquipment: 'Cargando equipo...',
      colSource: 'Origen',
      colEquipment: 'Equipo',
      colStatus: 'Estado',
      colEstHours: 'Horas est.',
      colCostHr: 'Costo/hora',
      colPriceHr: 'Precio/hora',
      colTotalCost: 'Costo total',
      colActions: 'Acciones',
      badgeAsset: 'Activo',
      // Sprint 31, story-149 (Instancia 2): distinto de `enumLabels.taskEquipmentStatusPlanned`
      // (ver en.ts) — esta insignia indica el origen del equipo, no su estado.
      badgePlanned: 'Planificado',
      returnEquipmentAction: 'Devolver equipo',
      checkoutReservedAction: 'Retirar equipo reservado',
      removeEquipmentAction: 'Quitar equipo',
      editEquipmentAction: 'Editar equipo',
      totals: 'Totales',
      noEquipmentAdded:
        'No se agregó equipo. Usa "Retirar de activos" para asignar equipo rastreado, "Reservar" para apartarlo, o "Agregar manualmente" para equipo no rastreado.',
      legendInUse: '= Retirado actualmente',
      legendReserved: '= Reservado para esta tarea',
      legendReturned: '= Devuelto al almacén',
      legendPlanned: '= Planificado (sin activo asignado)',
      legendManual: '= Agregado manualmente',
      units: 'unidades',
      hrs: 'hrs',
    },
    // Sprint 28, story-144 (residual gap). MaterialsSubTab.
    materials: {
      title: 'Materiales de la tarea',
      itemsCostSummary: '{n} artículos · Costo: {cost}',
      clientSuffix: ' · Cliente: {price}',
      calculator: 'Calculadora',
      addManually: 'Agregar manualmente',
      addFromWarehouse: 'Agregar desde almacén',
      infoBannerReserved: 'Reservado',
      infoBannerPlanned: 'Planificado',
      infoBannerPrefix: 'Los materiales pueden estar',
      infoBannerMiddle: '(apartados en el almacén) o',
      infoBannerSuffix:
        '(sin impacto en existencias). Los materiales reservados deben consumirse antes de descontar las existencias.',
      pendingReservationSingular:
        'material pendiente de reserva. Resérvalo cuando haya existencias disponibles.',
      pendingReservationPlural:
        'materiales pendientes de reserva. Resérvalos cuando haya existencias disponibles.',
      loadingMaterials: 'Cargando materiales...',
      colSource: 'Origen',
      colStatus: 'Estado',
      colMaterial: 'Material',
      colQuantity: 'Cantidad',
      colUnitCost: 'Costo unitario',
      colTotalCost: 'Costo total',
      colChargeClient: 'Cobrar al cliente',
      colClientPrice: 'Precio al cliente',
      colActions: 'Acciones',
      skuLabel: 'SKU: {sku}',
      reserveFromWarehouse: 'Reservar del almacén',
      insufficientStock: 'Existencias insuficientes (disponible: {n})',
      markAsConsumed: 'Marcar como consumido',
      returnToWarehouseAction: 'Devolver al almacén',
      removeMaterialAction: 'Quitar material',
      editMaterialAction: 'Editar material',
      totals: 'Totales',
      noMaterialsAdded:
        'No se agregaron materiales. Usa "Agregar desde almacén", "Agregar manualmente" o la calculadora para comenzar.',
      legendStockUpdated: '= Existencias actualizadas automáticamente',
      legendManual: '= Agregado manualmente',
      // Sprint 34, story-176. Estados de carga/error de la línea de resumen (docs/ux/story-176-design.md).
      summaryLoadError: 'No se pudieron cargar los totales',
      summaryRetry: 'Reintentar',
    },
    // Sprint 28, story-144 (residual gap). InventoryTab (pestañas de materiales/equipo + modales).
    inventoryTab: {
      saveTaskFirstTitle: 'Guarda la tarea primero',
      saveTaskFirstMessage:
        'Para gestionar materiales y equipo desde el almacén, guarda primero la tarea usando el botón Crear.',
      materialsTabLabel: 'Materiales',
      equipmentTabLabel: 'Equipo',
      removeMaterialTitle: 'Quitar material',
      removeMaterialConfirm: '¿Seguro que deseas quitar "{name}"?',
      reservedMaterialReleaseNote:
        'La reserva se liberará y las existencias volverán a estar disponibles.',
      plannedMaterialNoStockNote:
        'Este es un material planificado: no se producirán cambios en las existencias.',
      warehouseStockReturnedNote: 'Las existencias se devolverán al almacén.',
      remove: 'Quitar',
      cancel: 'Cancelar',
      removeEquipmentTitle: 'Quitar equipo',
      removeEquipmentConfirm: '¿Seguro que deseas quitar "{name}"?',
      reservedEquipmentCancelNote:
        'La reserva se cancelará y el activo volverá a estar disponible.',
      plannedEquipmentNoAssetNote:
        'Este es un equipo planificado: no se producirán cambios en el activo.',
      checkoutEquipmentTitle: 'Retirar equipo',
      checkoutEquipmentConfirm:
        '¿Seguro que deseas retirar "{name}"? Se completará la reserva y el estado del equipo cambiará a En uso.',
      checkout: 'Retirar',
    },
    // Sprint 28, story-144 (residual gap). DependenciesTab.
    dependencies: {
      otherTasksGroup: 'Otras tareas',
      wouldCreateCycle: '(crearía un ciclo)',
      alreadyImplied: '(ya está implícito)',
      mainBadge: 'Principal',
      removeAriaLabelPrefix: 'Quitar',
      precedingTaskLabel: 'Tarea precedente',
      precedingEventLabel: 'Evento precedente',
      searchPrecedingTasksPlaceholder: 'Busca y selecciona tareas precedentes...',
      selectPrecedingEventsPlaceholder: 'Selecciona eventos precedentes...',
      conflictTitle: 'La tarea precedente es posterior a la tarea actual',
      conflictThisEnds: 'Esta precedente termina',
      conflictTheseEnd: 'Estas precedentes terminan',
      conflictAfterThisTaskStartsOn: 'después de que esta tarea comienza el {date}',
      conflictAfterThisTaskStarts: 'después de que esta tarea comienza',
      conflictSaveAnywayNote:
        'Aún puedes guardar; la dependencia simplemente quedará fuera de orden.',
      conflictOccurs: 'ocurre',
      conflictEnds: 'termina',
    },
    // Sprint 28, story-144 (residual gap). ActivityTab.
    activityTab: {
      addActivity: 'Agregar actividad',
      selectedFiles: 'Archivos seleccionados ({n}):',
      removeFile: 'Quitar archivo',
      noteTitlePlaceholder: 'Título de la nota...',
      descriptionPlaceholder: 'Agrega una descripción o comentario...',
      attachFiles: 'Adjuntar archivos',
      addNote: 'Agregar nota',
      noActivitiesYet: 'Todavía no hay actividades',
      defaultNoteName: 'Nota',
    },
  },
  // Sprint 28, story-144 (residual gap). CreateEditEquipmentModal (formulario de equipo manual).
  equipmentModal: {
    nameMinLength: 'El nombre debe tener al menos 3 caracteres',
    nameRequired: 'El nombre es obligatorio',
    supplierOwnerRequired: 'El proveedor/propietario es obligatorio',
    supplyDeliveryDateRequired: 'La fecha de suministro/entrega es obligatoria',
    hoursUsedPositive: 'Las horas usadas deben ser positivas',
    hoursUsedRequired: 'Las horas usadas son obligatorias',
    amountPositive: 'La cantidad debe ser positiva',
    amountRequired: 'La cantidad es obligatoria',
    costPerHourPositive: 'El costo por hora debe ser positivo',
    costPerHourRequired: 'El costo por hora es obligatorio',
    pricePerHourPositiveWhenCharging: 'El precio por hora debe ser positivo',
    pricePerHourRequiredWhenCharging: 'El precio por hora es obligatorio al cobrar al cliente',
    pricePerHourPositive: 'El precio por hora debe ser positivo',
    saveChanges: 'Guardar cambios',
    addEquipment: 'Agregar equipo',
    editEquipment: 'Editar equipo',
    nameLabel: 'Nombre',
    equipmentNamePlaceholder: 'Nombre del equipo',
    supplierOwnerLabel: 'Proveedor/Propietario',
    equipmentSupplierPlaceholder: 'Proveedor/propietario del equipo',
    supplyDeliveryDateLabel: 'Fecha de suministro/entrega',
    hoursUsedLabel: 'Horas usadas (estimadas)',
    amountLabel: 'Cantidad (unidades)',
    costPerHourLabel: 'Costo por hora',
    chargeToClient: 'Cobrar al cliente',
    pricePerHourLabel: 'Precio por hora',
    rawProfit: 'Ganancia bruta ({amount})',
  },
  // Sprint 28, story-144 (residual gap). CreateEditMaterialModal (formulario de material manual).
  materialModal: {
    nameMinLength: 'El nombre debe tener al menos 3 caracteres',
    nameRequired: 'El nombre es obligatorio',
    supplierMinLength: 'El proveedor debe tener al menos 3 caracteres',
    supplierRequired: 'El proveedor es obligatorio',
    supplyDeliveryDateRequired: 'La fecha de suministro/entrega es obligatoria',
    amountPositive: 'La cantidad debe ser positiva',
    amountRequired: 'La cantidad es obligatoria',
    costPerUnitPositive: 'El costo por unidad debe ser positivo',
    costPerUnitRequired: 'El costo por unidad es obligatorio',
    pricePerUnitPositiveWhenCharging: 'El precio por unidad debe ser positivo',
    pricePerUnitRequiredWhenCharging: 'El precio por unidad es obligatorio al cobrar al cliente',
    pricePerUnitPositive: 'El precio por unidad debe ser positivo',
    unitRequired: 'La unidad es obligatoria',
    systemRequired: 'El sistema es obligatorio',
    saveChanges: 'Guardar cambios',
    addMaterial: 'Agregar material',
    editMaterial: 'Editar material',
    materialNameLabel: 'Nombre del material',
    materialNamePlaceholder: 'Nombre del material',
    supplierLabel: 'Proveedor',
    materialSupplierPlaceholder: 'Proveedor del material',
    supplyDeliveryDateLabel: 'Fecha de suministro/entrega',
    systemLabel: 'Sistema',
    metricImperialPlaceholder: 'Métrico/Imperial',
    unitLabel: 'Unidad',
    amountLabel: 'Cantidad',
    costPerUnitLabel: 'Costo por unidad',
    chargeToClient: 'Cobrar al cliente',
    pricePerUnitLabel: 'Precio por unidad',
    rawProfit: 'Ganancia bruta ({amount})',
  },
  // Sprint 28, story-144 (residual gap). CreateEditEventModal.
  eventModal: {
    nameMinLength: 'El nombre debe tener al menos 3 caracteres',
    nameRequired: 'El nombre es obligatorio',
    eventTypeRequired: 'El tipo de evento es obligatorio',
    eventTimeRequired: 'La hora del evento es obligatoria',
    otherEventTypeMinLength: 'El otro tipo de evento debe tener al menos 3 caracteres',
    otherEventTypeRequired: 'El otro tipo de evento es obligatorio',
    incidentTypeRequired: 'El tipo de incidente es obligatorio',
    addedIncidentTypeMinLength: 'El tipo de incidente agregado debe tener al menos 3 caracteres',
    addedIncidentTypeRequired: 'El tipo de incidente agregado es obligatorio',
    inspectionTypeRequired: 'El tipo de inspección es obligatorio',
    permitMinLength: 'El permiso debe tener al menos 3 caracteres',
    permitRequired: 'El permiso es obligatorio',
    delayPositive: 'El retraso debe ser positivo',
    delayRequired: 'El retraso es obligatorio',
    delayTypeRequired: 'El tipo de retraso es obligatorio',
    notesMinLength: 'Las notas deben tener al menos 3 caracteres',
    notesRequired: 'Las notas son obligatorias',
    atLeastOnePrecedingTask: 'Se requiere al menos una tarea precedente',
    eventUpdatedSuccess: 'Evento actualizado correctamente',
    eventCreatedSuccess: 'Evento creado correctamente',
    eventUpdateFailed: 'No se pudo actualizar el evento',
    eventCreateFailed: 'No se pudo crear el evento',
    saveChanges: 'Guardar cambios',
    createEvent: 'Crear evento',
    editEvent: 'Editar evento',
    nameLabel: 'Nombre',
    enterEventNamePlaceholder: 'Ingresa el nombre del evento',
    eventTypeLabel: 'Tipo de evento',
    selectEventTypePlaceholder: 'Selecciona el tipo de evento',
    otherEventTypeLabel: 'Otro tipo de evento',
    enterOtherEventTypePlaceholder: 'Ingresa el otro tipo de evento',
    eventTimeLabel: 'Hora del evento',
    selectDatePlaceholder: 'Selecciona la fecha',
    incidentTypeLabel: 'Tipo de incidente',
    selectIncidentTypePlaceholder: 'Selecciona el tipo de incidente',
    addIncidentTypeLabel: 'Agregar tipo de incidente',
    enterIncidentTypePlaceholder: 'Ingresa el tipo de incidente',
    inspectionTypeLabel: 'Tipo de inspección',
    selectInspectionTypePlaceholder: 'Selecciona el tipo de inspección',
    permitLabel: 'N.º de permiso',
    enterPermitNumberPlaceholder: 'Ingresa el número de permiso',
    delayLabel: 'Retraso',
    delayTypeLabel: 'Tipo de retraso',
    selectTimeTypePlaceholder: 'Selecciona el tipo de tiempo',
    // Sprint 28, develop run 3 (story-144 review Critical #1 fix).
    delayUnitHours: 'horas',
    delayUnitDays: 'días',
    delayUnitWeeks: 'semanas',
    notesLabel: 'Notas',
    enterNotesPlaceholder: 'Ingresa las notas',
    precedingTasksLabel: 'Tareas precedentes *',
    selectPrecedingTasksPlaceholder: 'Selecciona las tareas precedentes',
  },
  // Sprint 29, story-148 — ver en.ts para el comentario completo.
  enumLabels: {
    equipmentStatusAvailable: 'Disponible',
    equipmentStatusInUse: 'En uso',
    equipmentStatusMaintenance: 'En mantenimiento',
    equipmentStatusReserved: 'Reservado',
    equipmentStatusRetired: 'Retirado',
    invoiceStatusDraft: 'Borrador',
    invoiceStatusSending: 'Enviando',
    invoiceStatusSent: 'Enviada',
    invoiceStatusPaid: 'Pagada',
    invoiceStatusVoided: 'Anulada',
    invoiceStatusSendFailed: 'Envío fallido',
    transactionTypeReceive: 'Recibido',
    transactionTypeConsume: 'Consumido',
    transactionTypeAdjust: 'Ajustado',
    transactionTypeReserve: 'Reservado',
    transactionTypeReleaseReserve: 'Liberado',
    transactionTypeReturn: 'Devuelto',
    transactionTypeRecovery: 'Recuperado',
    transactionTypeTransfer: 'Transferido',
    transactionTypeUseAsEquipment: 'Equipo',
    taskMaterialStatusPlanned: 'Planificado',
    taskMaterialStatusReserved: 'Reservado',
    taskMaterialStatusConsumed: 'Consumido',
    taskMaterialStatusReturned: 'Devuelto',
    // Sprint 31, story-149 (Instancia 2). Migrado de `taskDetail.equipment.status*` (ver en.ts).
    taskEquipmentStatusPlanned: 'Planificado',
    taskEquipmentStatusReserved: 'Reservado',
    taskEquipmentStatusInUse: 'En uso',
    taskEquipmentStatusReturned: 'Devuelto',
    shapeTypeCircle: 'Círculo',
    shapeTypePolygon: 'Polígono',
    roleSuperAdmin: 'Superadministrador',
    roleOwner: 'Propietario',
    roleAdmin: 'Administrador',
    // Sentence case, not Title Case, for a standalone label/badge value — architecture.md
    // Addendum 8's recommended house-style rule, applied here ahead of UX formalizing it as
    // house-style.md §9 (routed, not yet landed as of this story's development).
    roleProjectManager: 'Gerente de proyecto',
    roleSuperintendent: 'Superintendente',
    roleCrewLead: 'Líder de cuadrilla',
    roleEmployee: 'Empleado',
    roleReviewer: 'Revisor',
    roleClient: 'Cliente',
    adjustmentReasonCountCorrection: 'Corrección de conteo',
    adjustmentReasonDamaged: 'Dañado',
    adjustmentReasonLost: 'Perdido',
    adjustmentReasonStolen: 'Robado',
    adjustmentReasonBroken: 'Roto',
    adjustmentReasonExpired: 'Vencido',
    adjustmentReasonFound: 'Encontrado',
    adjustmentReasonTransfer: 'Transferencia',
    adjustmentReasonOther: 'Otro',
    transactionStatusPending: 'Pendiente',
    transactionStatusCompleted: 'Completada',
    transactionStatusCancelled: 'Cancelada',
    stockStatusInStock: 'En existencia',
    stockStatusLowStock: 'Existencias bajas',
    stockStatusOutOfStock: 'Agotado',
    equipmentConditionGood: 'Bueno',
    equipmentConditionFair: 'Regular',
    equipmentConditionNeedsRepair: 'Necesita reparación',
    transactionKindPurchase: 'Compra',
    transactionKindDraw: 'Retiro',
    transactionKindAdjustment: 'Ajuste',
    transactionKindTransfer: 'Transferencia',
    transactionKindReturn: 'Devolución',
    transactionKindReserve: 'Reserva',
    transactionKindRelease: 'Liberación',
    transactionKindRecovery: 'Recuperación',
    // Sprint 31, story-157.
    billingTransactionStatusSuccess: 'Correcto',
    billingTransactionStatusFailed: 'Fallido',
    billingTransactionStatusPending: 'Pendiente',
    billingTransactionStatusRefunded: 'Reembolsado',
    billingTransactionTypeCharge: 'Cargo',
    billingTransactionTypeRefund: 'Reembolso',
    billingTransactionTypeRetry: 'Reintento',
    subscriptionStatusTrial: 'Período de prueba',
    subscriptionStatusTrialExpired: 'Prueba finalizada — solo lectura',
    subscriptionStatusActive: 'Activa',
    subscriptionStatusPastDue: 'Vencida',
    subscriptionStatusCanceled: 'Cancelada',
    subscriptionStatusPaused: 'Pausada',
    paymentMethodTypeCreditCard: 'Tarjeta de crédito',
    paymentMethodTypeAch: 'Cuenta bancaria (ACH)',
    paymentMethodTypeDigitalWallet: 'Billetera digital',
    // Sprint 31, story-158.
    fileKindImageOne: 'Imagen',
    fileKindImageOther: 'Imágenes',
    fileKindPdfOne: 'Documento PDF',
    fileKindPdfOther: 'Documentos PDF',
    fileKindSheetOne: 'Hoja de cálculo',
    fileKindSheetOther: 'Hojas de cálculo',
    fileKindDocOne: 'Documento',
    fileKindDocOther: 'Documentos',
    fileKindArchiveOne: 'Archivo comprimido',
    fileKindArchiveOther: 'Archivos comprimidos',
    fileKindOtherOne: 'Archivo',
    fileKindOtherOther: 'Archivos',
  },
  // Sprint 28, story-144 (residual gap). PaymentMethodSelector/validationSchema.ts — archivo .ts
  // sin componente según la Decisión 2, así que las cadenas traducidas se construyen mediante una
  // función factory llamada desde el/los componente(s) consumidor(es), nunca con un hook dentro de
  // este archivo.
  paymentMethod: {
    selectPaymentMethodRequired: 'Selecciona un método de pago',
    firstNameRequired: 'El nombre es obligatorio',
    lastNameRequired: 'El apellido es obligatorio',
    invalidEmail: 'Correo electrónico inválido',
    emailRequired: 'El correo electrónico es obligatorio',
    addressRequired: 'La dirección es obligatoria',
    cityRequired: 'La ciudad es obligatoria',
    stateFormat: 'El estado debe tener 2 letras (por ejemplo, CA)',
    stateRequired: 'El estado es obligatorio',
    zipRequired: 'El código postal es obligatorio',
    phoneFormat:
      'El número de teléfono solo puede contener dígitos, espacios, guiones, paréntesis y el signo más',
    phoneMinLength: 'El número de teléfono debe tener al menos 10 dígitos',
    phoneRequiredAch: 'El número de teléfono es obligatorio para pagos ACH',
    cardNumberRequired: 'El número de tarjeta es obligatorio',
    invalidCardNumber: 'Número de tarjeta inválido',
    expirationRequired: 'La fecha de vencimiento es obligatoria',
    expirationFormat: 'El formato debe ser MM/AA',
    cardExpired: 'La tarjeta ha vencido',
    cvvRequired: 'El CVV es obligatorio',
    cvvFormat: 'El CVV debe tener 3 o 4 dígitos',
    accountHolderNameRequired: 'El nombre del titular de la cuenta es obligatorio',
    routingNumberFormat: 'El número de ruta debe tener 9 dígitos',
    routingNumberRequired: 'El número de ruta es obligatorio',
    accountNumberRequired: 'El número de cuenta es obligatorio',
    accountTypeRequired: 'El tipo de cuenta es obligatorio',
    accountHolderTypeRequired: 'El tipo de titular de la cuenta es obligatorio',
  },
  // Sprint 31, story-157.
  billing: {
    cannotUndoWarning: 'Esta acción no se puede deshacer',
    seats: {
      addSeatsButton: 'Agregar puestos',
      yourSubscriptionTitle: 'Tu suscripción',
      manageSubtitle: 'Administra tu plan y los puestos adquiridos',
      basePlanBadge: 'Plan base',
      standardPlanFallback: 'Plan estándar',
      priceLabel: 'Precio:',
      seatsLabelColon: 'Puestos:',
      sinceLabel: 'Desde:',
      perYearSuffix: 'año',
      perMonthSuffix: 'mes',
      addonBadge: 'Complemento',
      removeAddonTitle: 'Quitar complemento',
      noAdditionalSeatsMessage: 'Aún no has comprado puestos adicionales.',
      clickAddSeatsHint: 'Haz clic en "Agregar puestos" para comprar más.',
      totalMonthlyCostLabel: 'Costo mensual total',
      totalSeatsLabel: 'Puestos totales',
      fromBasePlanSuffix: '{n} del plan base',
      fromAddonsOne: '{seats} de {count} complemento',
      fromAddonsOther: '{seats} de {count} complementos',
      removeAddonModalTitle: 'Quitar complemento',
      removeButton: 'Quitar',
      noSubscriptionFound: 'No se encontró ninguna suscripción',
      cannotRemoveTitle: 'No se puede quitar este complemento',
      cannotRemoveBody1Prefix: 'Actualmente tienes',
      activeUserOne: '{n} usuario activo',
      activeUserOther: '{n} usuarios activos',
      cannotRemoveBody1Suffix:
        'usando tus puestos. Quitar este complemento te dejaría con puestos insuficientes.',
      cannotRemoveBody2Prefix: 'Para quitar este complemento, debes desactivar al menos',
      userOne: '{n} usuario',
      userOther: '{n} usuarios',
      cannotRemoveBody2Suffix: 'primero desde la',
      usersPageLink: 'página de usuarios',
      confirmRemovePrefix: '¿Estás seguro de que deseas quitar',
      removeSeatWarningOne: 'Esto quitará {n} puesto de tu suscripción.',
      removeSeatWarningOther: 'Esto quitará {n} puestos de tu suscripción.',
      removeAddonFinalNote:
        'La suscripción del complemento se cancelará. No se emitirá ningún reembolso por el período restante.',
      additionalSeatOne: '{n} puesto adicional',
      additionalSeatOther: '{n} puestos adicionales',
      includedSeatOne: '{n} puesto incluido',
      includedSeatOther: '{n} puestos incluidos',
      seatUsageModalTitle: 'Uso de puestos',
      seatsUsedSuffix: '{active} de {total} puestos usados',
      overSeatLimitCaption: 'Superaste el límite de puestos',
      noSeatsAvailableCaption: 'No hay puestos disponibles',
      seatsAvailableSuffix: '{n} disponibles',
      billedPerSeatFooter: 'Se te cobra por puesto según tu plan.',
      allRolesCountFooter: 'Tu plan cuenta cada rol como un puesto.',
      someRolesFreeFooter:
        'Tu plan define qué roles usan un puesto. Puedes agregar estos roles sin usar puestos.',
      usesSeatHeading: 'Usa un puesto',
      freeNoSeatHeading: 'Libre — sin puesto',
      // Sprint 31, story-158.
      roleAdminSingular: 'administrador',
      roleAdminPlural: 'administradores',
      roleOwnerSingular: 'propietario',
      roleOwnerPlural: 'propietarios',
      roleProjectManagerSingular: 'gerente de proyecto',
      roleProjectManagerPlural: 'gerentes de proyecto',
      roleSuperintendentSingular: 'superintendente',
      roleSuperintendentPlural: 'superintendentes',
      roleCrewLeadSingular: 'líder de cuadrilla',
      roleCrewLeadPlural: 'líderes de cuadrilla',
      roleEmployeeSingular: 'empleado',
      roleEmployeePlural: 'empleados',
      roleReviewerSingular: 'revisor',
      roleReviewerPlural: 'revisores',
      noSeatNoteOne: 'El {role} no usa un puesto.',
      noSeatNoteOther: '{roleList} no usan un puesto.',
      seatWarningOne: 'Recuerda, el {role} no ocupa puestos.',
      seatWarningOther: 'Recuerda, {roleList} no ocupan puestos.',
      roleListArticle: 'los ',
      listConjunction: 'y',
      listConjunctionBeforeI: 'e',
    },
    paymentMethods: {
      title: 'Métodos de pago',
      addButton: 'Agregar método de pago',
      addFailedFallback: 'No se pudo agregar el método de pago',
      lockedTitle: 'Tu organización está bloqueada — agrega un método de pago para continuar',
      lockedBodyPrefix: 'Tu prueba gratuita ha terminado. Hasta que se agregue un método de pago,',
      lockedBodyEmphasis: 'todo cambio está bloqueado',
      lockedBodySuffix:
        '— no se pueden guardar proyectos, tareas, clientes ni registros de tiempo nuevos, ni por ti ni por nadie de tu equipo.',
      lockedDataSafe:
        'Tus datos están seguros y siguen siendo legibles. Agregar una tarjeta restaura el acceso completo de inmediato.',
      addNowButton: 'Agregar método de pago ahora',
      noPaymentMethodsTitle: 'Sin métodos de pago',
      noPaymentMethodsBody:
        'Aún no has agregado ningún método de pago. Agrega uno para administrar tu suscripción.',
      defaultBadge: 'Predeterminado',
      expiresSuffix: 'Vence {month}/{year}',
      expSuffix: 'Vence {month}/{year}',
      setAsDefaultButton: 'Establecer como predeterminado',
      deleteButtonTitle: 'Eliminar método de pago',
      deleteModalTitle: 'Eliminar método de pago',
      deleteConfirmBody: '¿Estás seguro de que deseas eliminar este método de pago?',
      deleteWarning: 'Esta acción no se puede deshacer.',
    },
    subscription: {
      pageTitle: 'Facturación y suscripción',
      pageSubtitle: 'Administra tu suscripción, métodos de pago e historial de facturación',
      confirmPause: '¿Estás seguro de que deseas pausar tu suscripción?',
      confirmStart:
        '¿Estás seguro de que deseas activar la facturación de tu suscripción? Se te cobrará en tu próxima fecha de facturación.',
      organizationFallback: 'Organización',
      canceledTitle: 'Suscripción cancelada',
      canceledBodySuffix:
        'ahora está suspendida y su equipo ha perdido el acceso. Tus datos se conservan por si decides volver.',
      continueButton: 'Continuar',
      cancelSubscriptionButton: 'Cancelar suscripción',
      undoneNoPeriod: 'Esta acción no se puede deshacer',
      consequencesHeading: 'Al cancelar tu suscripción:',
      consequenceGrandfatheringBold: 'Perderás tus beneficios de precio anterior.',
      consequenceGrandfatheringBody:
        'Si te vuelves a suscribir más adelante, podrías estar sujeto a precios diferentes.',
      consequenceAccessBold: 'Perderás el acceso a tu organización.',
      consequenceAccessBody: 'Tus datos no se eliminarán por si decides regresar.',
      consequenceEmployeesBold: 'Todos los empleados serán deshabilitados.',
      consequenceEmployeesBody: 'Todo el equipo perderá el acceso de inmediato.',
      confirmTypePrefix: 'Para confirmar, escribe',
      confirmTypeSuffix: 'a continuación:',
      confirmPlaceholder: 'Escribe "{org}" para confirmar',
      mismatchPrefix: 'Eso no coincide. Escribe',
      mismatchSuffix: 'exactamente para habilitar el botón.',
      keepSubscriptionButton: 'Mantener suscripción',
      noActiveSubscriptionTitle: 'Sin suscripción activa',
      noActiveSubscriptionBody:
        'Aún no tienes una suscripción activa. Comunícate con soporte para configurar tu suscripción.',
      activateOneStepTitle: 'Falta un paso — activa tu suscripción',
      cardEndingPrefix: 'Tu tarjeta que termina en',
      cardEndingMiddle: 'está guardada, pero tu organización sigue',
      stillReadOnlyEmphasis: 'en modo de solo lectura',
      cardSavedTail:
        '. Guardar una tarjeta no activa una suscripción — actívala para restaurar el acceso completo para ti y tu equipo.',
      activateSubscriptionButton: 'Activar suscripción',
      activateModalTitle: 'Activa tu suscripción',
      activateModalDescription:
        'A tu tarjeta que termina en {last4} se le cobrará {price} por {period}, a partir de hoy. El acceso completo se restaura de inmediato.',
      activateAndPayButton: 'Activar y pagar',
      notNowButton: 'Ahora no',
      paymentFailedTitle: 'Pago fallido',
      paymentFailedBody:
        'Tu método de pago fue rechazado. Actualiza tu información de pago para seguir usando Zenhammer.',
      trialPeriodActiveTitle: 'Período de prueba activo',
      trialEndsBodyPrefix: 'Tu prueba gratuita termina el',
      trialEndsBodySuffix: 'No se te cobrará hasta después del período de prueba.',
      billingNotActiveTitle: 'Facturación no activa',
      billingNotActiveBodyPrefix: 'Tu plan ha sido asignado, pero la facturación aún no está activa.',
      billingNotActiveWithCard: 'Haz clic en "Iniciar facturación" para activar tu suscripción.',
      billingNotActiveWithoutCard: 'Agrega un método de pago para iniciar tu suscripción.',
      detailsTitle: 'Detalles de la suscripción',
      planAmountLabel: 'Plan y monto',
      billedPrefix: 'Facturación',
      periodAnnual: 'anual',
      periodMonthly: 'mensual',
      startDateLabel: 'Fecha de inicio',
      trialEndsLabel: 'Fin de la prueba',
      canceledAtLabel: 'Cancelada el',
      seatsLabel: 'Puestos',
      seatsUsedSuffix: '{active} de {total} usados',
      seatsAvailablePrefix: 'Estás usando {active} de {total} puestos —',
      seatsAvailableSuffix: 'libres.',
      seatsAllUsedMessage: 'Todos los {total} puestos están en uso. Agrega puestos para invitar a más personas.',
      startBillingButton: 'Iniciar facturación',
      addPaymentMethodToStartButton: 'Agregar método de pago para iniciar',
      resumeSubscriptionButton: 'Reanudar suscripción',
    },
    history: {
      title: 'Historial de facturación',
      loading: 'Cargando...',
      noTransactionsTitle: 'Sin transacciones',
      noTransactionsBody: 'Aún no tienes transacciones de facturación.',
      transactionIdPrefix: 'ID de transacción:',
      loadMoreButton: 'Cargar más transacciones',
    },
  },
  // Sprint 28, story-144 (residual gap). pages/projects/components — subcomponentes restantes del
  // detalle de proyecto (tarjetas de presupuesto, gestor de documentos, pestaña de evidencia, lista
  // de materiales).
  projectComponents: {
    budgetCard: {
      title: 'Presupuesto',
      totalCost: 'Costo total',
      maxBudget: 'Presupuesto máximo',
      progress: 'Progreso',
      materials: 'Materiales',
      details: 'Detalles',
    },
    timelineCard: {
      title: 'Cronograma',
      start: 'Inicio',
      end: 'Fin',
      totalManHours: 'Total de horas-hombre',
      progress: 'Progreso',
      import: 'Importar',
      schedule: 'Cronograma',
      generateWithAi: 'Generar con IA',
      ai: 'IA',
    },
    delegatedTasksTab: {
      colTaskName: 'Nombre de la tarea',
      colDelegatedTo: 'Delegado a',
      colAcceptedBudget: 'Presupuesto aceptado',
      emptyMessage: 'No hay tareas delegadas con presupuestos aceptados',
      totalDelegatedCost: 'Costo total delegado',
    },
    allItemsTab: {
      colCategory: 'Categoría',
      colNameDescription: 'Nombre / Descripción',
      colTotalCost: 'Costo total',
      emptyMessage: 'No hay elementos de presupuesto',
      grandTotal: 'Total general',
      categoryMaterial: 'Material',
      categoryEquipment: 'Equipo',
      categoryDelegated: 'Delegado',
      categoryLineItem: 'Partida',
    },
    budgetSummaryHeader: {
      onBudget: 'DENTRO DEL PRESUPUESTO',
      overBudget: 'SOBRE PRESUPUESTO',
      delegated: 'Delegado',
      owned: 'Propio',
      materialsCount: '{n} materiales',
      equipmentCount: '{n} equipo',
      delegatedCount: '{n} delegado',
      lineItemsCount: '{n} partidas',
      materials: 'Materiales',
      equipment: 'Equipo',
      delegatedLabel: 'Delegado',
      lineItems: 'Partidas',
      from: 'De:',
      client: 'Cliente:',
      pm: 'Gerente:',
      supt: 'Superint.:',
      budget: 'Presupuesto:',
      spent: 'Gastado:',
    },
    documents: {
      addDocuments: 'Agregar documentos',
      manageAllDocuments: 'Gestionar todos los documentos',
      categoryLabel: 'Categoría: {category}',
      kbOf: '{used} KB de {total} KB • Subiendo…',
      completed: 'Completado',
      uploadFailed: 'Error al subir',
      uploadDisabled: 'La carga está deshabilitada',
      uploadingFiles: 'Subiendo archivos...',
      dropFilesHere: 'Suelta los archivos aquí…',
      chooseOrDrag: 'Elige un archivo o arrástralo y suéltalo aquí.',
      selectCategoryFirstHint: 'Selecciona una categoría arriba para habilitar la carga de archivos',
      acceptedFormatsHint: 'Formatos JPEG, PNG, PDF y MP4, hasta 50 MB.',
      browseFile: 'Examinar archivo',
      done: 'Listo',
      manageDocumentsTitle: 'Gestionar documentos',
      manageDocumentsDescription:
        'Sube y gestiona los documentos de tu proyecto. También puedes agregar categorías a tus documentos para ayudarte a organizarlos.',
      categoryFieldLabel: 'Categoría',
      selectCategoryPlaceholder: 'Selecciona una categoría',
      selectCategoryFirst: 'Selecciona primero una categoría',
      dropDocumentsHere: 'Suelta los documentos aquí o haz clic para seleccionar',
      documentsSubtitle: 'PDF, TXT, CSV, imágenes de hasta 50MB cada una',
      pleaseSelectCategory: 'Selecciona una categoría',
    },
    evidenceTab: {
      loadError: 'No se pudo cargar la evidencia. Inténtalo de nuevo.',
      noTasksYet: 'Todavía no hay tareas: la evidencia aparecerá aquí cuando se creen tareas.',
    },
    billOfMaterials: {
      title: 'Lista de materiales',
      fullProject: 'Proyecto completo',
      detailedByTask: 'Detallado por tarea',
      printExport: 'Imprimir / Exportar',
      generated: 'Generado: {date}',
      view: 'Vista: {mode}',
      totalItems: 'Total de artículos',
      materials: 'Materiales',
      equipment: 'Equipo',
      totalCost: 'Costo total',
      close: 'Cerrar',
    },
  },
  // Sprint 28, story-144 (residual gap). pages/projects/components/ProjectFeed — 14 renderizadores
  // de tarjetas de actividad. Las etiquetas de campo compartidas van en el nivel superior; el
  // texto propio de cada tarjeta va anidado.
  // Sprint 31, story-149 (Instancia 1). Renombrado de `projectFeed` a `activityCards` (ver en.ts).
  activityCards: {
    taskLabel: 'Tarea:',
    projectLabel: 'Proyecto:',
    notAvailable: 'N/D',
    taskTypeLabel: 'Tipo de tarea:',
    createdByLabel: 'Creado por {org}',
    maxBidLabel: 'Oferta máxima:',
    timelineLabel: 'Cronograma:',
    sentToLabel: 'Enviado a:',
    byLabel: 'Por',
    crewAssign: {
      crewAssigned: 'Cuadrilla asignada',
    },
    delegationCanceled: {
      taskDelegationCancelled: 'Delegación de tarea cancelada',
      delegationCancelledPanel: 'Delegación cancelada',
      availableForReassignmentHint:
        'Esta tarea ahora está disponible para reasignarla a tu equipo o para enviar solicitudes de oferta.',
      description:
        'La delegación de esta tarea fue cancelada y la tarea ahora está disponible para reasignación.',
    },
    note: {
      addedNote: 'Nota agregada - {time}',
      attemptedAt: '↳ Intento a las - {time}',
      attachments: 'Archivos adjuntos ({n})',
    },
    communication: {
      communication: 'Comunicación',
      communicationTime: 'Comunicación - {time}',
      documentFallback: 'Documento',
    },
    taskStatus: {
      statusActive: 'Tarea activa',
      statusInactive: 'Tarea inactiva',
      statusComplete: 'Tarea completada',
      statusRejected: 'Tarea rechazada',
      statusCanceled: 'Tarea cancelada',
      statusInternalApproval: 'Tarea en aprobación interna',
      statusClientApproval: 'Tarea en aprobación del cliente',
      statusDelegationCanceled: 'Tarea con delegación cancelada',
      rejectionReason: 'Motivo del rechazo',
    },
    budgetRequestRejected: {
      bidProposalRejected: 'Oferta rechazada',
    },
    budgetProposalCountered: {
      bidProposalCountered: 'Oferta contrapropuesta',
      biddProposalCounteredBy: 'Contrapropuesta enviada por {org}',
      originalProposalLabel: 'Oferta original:',
      originalRequestBy: 'Solicitud original de {org}',
      requestedTimelineLabel: 'Cronograma solicitado:',
      originalRequestDescriptionLabel: 'Descripción de la solicitud original:',
    },
    budgetProposalAccepted: {
      bidProposalAccepted: 'Oferta aceptada',
      acceptedAmountLabel: 'Monto aceptado:',
    },
    budgetRequestCreated: {
      bidRequestCreated: 'Solicitud de oferta creada',
    },
    budgetRequestSubmitted: {
      bidProposalSubmitted: 'Oferta enviada -',
      proposedSubmittedBy: 'Oferta enviada por {org}',
    },
    budgetRequestAccepted: {
      bidRequestAccepted: 'Solicitud de oferta aceptada',
    },
    geofence: {
      geofenceButton: 'Geocerca',
      enter: 'ENTRADA',
      exit: 'SALIDA',
    },
    invoicePending: {
      pendingToInvoice: 'Pendiente de facturar',
      equipmentSingular: 'Equipo',
      equipmentPlural: 'Equipos',
      materialSingular: 'Material',
      materialPlural: 'Materiales',
      noPendingItems: 'Sin elementos pendientes',
      resolved: 'Resuelto',
      createInvoice: 'Crear factura',
      awaitingInvoicing: 'Pendiente de facturación por el gerente',
      defaultTaskName: 'Tarea',
    },
    punchClock: {
      clockedIn: 'Entrada marcada',
      clockedOut: 'Salida marcada',
      userLabel: 'Usuario:',
      defaultUser: 'Usuario',
      geofenceButton: 'Geocerca',
    },
    incident: {
      incidentAcknowledged: 'Incidente reconocido',
      incidentReported: 'Incidente reportado',
      attemptedAt: '↳ Intento a las - {time}',
      incidentLabel: 'Incidente:',
      affectedTasksLabel: 'Tareas afectadas:',
      acknowledgedLabel: 'INCIDENTE RECONOCIDO',
      acknowledgedByLabel: 'Reconocido por:',
      originalIncidentLabel: 'Incidente original:',
      typeLabel: 'Tipo:',
      clickToAcknowledge: 'Haz clic para reconocer este incidente',
      clickToAcknowledgeBadge: 'Clic para reconocer',
      timeOfIncident: 'Hora del incidente: {time}',
      delayLabel: 'Retraso:',
      statusLabel: 'Estado:',
      statusPending: 'Pendiente',
      statusAcknowledged: 'Reconocido',
      acknowledgeButton: 'Reconocer',
      needsAttentionHint:
        'Este incidente requiere tu atención. Haz clic en la insignia de arriba o en el botón de reconocer para revisarlo y reconocerlo.',
      attachments: 'Archivos adjuntos ({n})',
      documentFallback: 'Documento',
      incidentDetailsTitle: 'Detalles del incidente',
      detailsSectionLabel: 'Detalles',
      reportedByLabel: 'Reportado por:',
      unknownTypeFallback: 'Desconocido',
      todayAtPrefix: 'Hoy a las {time}',
      dateAtTimeFormat: '{date} a las {time}',
      acknowledgedOnPrefix: 'el {date}',
      acknowledgeConfirmTitle: '¿Reconocer este incidente?',
      acknowledgeConfirmBody:
        'Esta acción marcará el incidente como reconocido y registrará que revisaste esta alerta. Otros usuarios podrán ver que reconociste este incidente. Esta acción no se puede deshacer.',
      acknowledgeIncidentButton: 'Reconocer incidente',
      acknowledgingButton: 'Reconociendo...',
    },
  },
  // Sprint 31, story-149 (Instancia 1). Extraído de `projectFeed`/`activityCards` — mismas
  // claves y valores que el `activityFeed` de mobile (`redesign/src/i18n/es.ts`).
  activityFeed: {
    noActivitiesToDisplay: 'No hay actividades para mostrar',
    noMoreActivities: 'No hay más actividades',
  },
  // Sprint 28, story-142. Web-only — ver docs/architecture.md "## Sprint 28" Decisión 1.
  home: {
    welcomeTitle: 'Bienvenido al panel web de ZenHammer',
    useMobileApp:
      'Si inicias sesión como Empleado o Líder de cuadrilla, usa la app móvil para la mejor experiencia.',
    logout: 'Cerrar sesión',
  },
  // Sprint 28, story-143. Páginas post-autenticación de estado de cuenta/organización.
  orgLifecycle: {
    checkingAccountStatus: 'Verificando el estado de la cuenta...',
    userDisabledTitle: 'Cuenta deshabilitada',
    userDisabledMessage:
      'Tu cuenta ha sido deshabilitada en todas tus organizaciones. Contacta a un administrador para recuperar el acceso.',
    whatCanYouDo: '¿Qué puedes hacer?',
    userDisabledBulletAdmin:
      'Contacta al administrador de tu organización para solicitar la reactivación de tu cuenta',
    userDisabledBulletSupport:
      'Si crees que esto es un error, comunícate con nuestro equipo de soporte',
    userDisabledBulletTryAgain:
      'Una vez reactivada, haz clic en "Reintentar" para acceder al sistema',
    userDisabledBulletNewOrg: 'Crea una nueva organización para empezar de cero',
    createNewOrganization: 'Crear nueva organización',
    tryAgain: 'Reintentar',
    contactSupport: 'Contactar soporte',
    needHelp: '¿Necesitas ayuda? Escríbenos a support@zenhammer.com',
    noOrganizationTitle: 'Aún no formas parte de una organización',
    noOrganizationMessage:
      'Pide a un administrador que te invite, o crea tu propia organización para comenzar.',
    noOrganizationHint:
      'Crea tu propia organización para empezar a usar Zenhammer, o espera una invitación de tu equipo.',
    createAnOrganization: 'Crear una organización',
    checking: 'Verificando...',
    checkForOrganization: 'Buscar organización',
    organizationFoundRedirecting: '¡Organización encontrada! Redirigiendo...',
    noOrganizationFoundYet:
      'Aún no se encontró ninguna organización. Revisa tu correo o crea una.',
    failedToCheckOrganization: 'No se pudo buscar la organización',
    organizationCreatedRedirecting: '¡Organización creada correctamente! Redirigiendo...',
    organizationCreatedNotAssigned:
      'La organización se creó pero no está asignada al usuario. Actualiza la página.',
    failedToLoadOrganization: 'No se pudo cargar la organización. Actualiza la página.',
    expectingInvitationHint:
      'Si esperas una invitación, revisa tu bandeja de entrada y la carpeta de spam.',
    pullToRefreshHint:
      'Desliza hacia abajo para actualizar y verificar si te agregaron a una organización.',
    organizationDisabledTitle: 'Tu organización ha sido deshabilitada',
    organizationDisabledMessage: 'Contacta a tu administrador para más información.',
    organizationSuspendedTitle: 'Organización suspendida',
    organizationSuspendedMessage: 'Tu organización ha sido suspendida por un problema de pago.',
    checkingOrganizationStatus: 'Verificando el estado de la organización...',
    ownerReactivateHint:
      'Como propietario de la organización, puedes reactivar tu suscripción agregando un nuevo método de pago, o crear una nueva organización.',
    reactivateSubscription: 'Reactivar suscripción',
    reactivateRestoreHint:
      'Reactivar tu suscripción restaurará el acceso a tu organización y todos sus datos.',
    nonOwnerSuspendedHint:
      'Contacta al administrador de tu organización para resolver este problema, o crea tu propia organización para seguir usando Zenhammer.',
    nonOwnerErrorHint:
      'Si crees que esto es un error, contacta al propietario o administrador de tu organización.',
    nonOwnerBillingHint: 'Ellos pueden actualizar el método de pago en la configuración de facturación.',
    reactivateSubscriptionFor: 'Reactivar la suscripción de {org}',
    reactivateFailedError: 'No se pudo reactivar la suscripción. Inténtalo de nuevo.',
    reactivateInfoBanner:
      'Tu organización {org} ha sido suspendida. Completa el siguiente formulario para reactivar tu suscripción y restaurar el acceso.',
    activeOrganizationsHeading: 'Tienes organizaciones activas:',
    switchOrganization: 'Cambiar',
    suspendedOrganizationsHeading: 'Organizaciones suspendidas que puedes reactivar:',
    suspendedBadge: 'Suspendida',
    reactivate: 'Reactivar',
    disabledOrganizationsHeading: 'Organizaciones donde tu cuenta está deshabilitada:',
    disabledBadge: 'Deshabilitada',
    contactAdmin: 'Contacta al administrador',
    trialExpiredTitle: 'Tu prueba gratuita ha terminado',
    trialExpiredMessage: 'Suscríbete para seguir usando ZenHammer sin interrupciones.',
    nothingToDoHere: 'Nada que hacer aquí',
    subscriptionGoodStanding: 'La suscripción de esta organización está al día.',
    backToDashboard: 'Volver al tablero',
    trialEndedForOrg: 'La prueba gratuita de {org} ha terminado',
    teamCanStillOpen:
      'Tu equipo todavía puede abrir y leer todo: proyectos, tareas, documentos y fotos están intactos. Crear y editar está pausado hasta que el propietario de la cuenta agregue un método de pago.',
    onlyOwnerCanRestore:
      'Solo el propietario de la cuenta puede hacer eso, así que contáctalo para restaurar el acceso completo.',
    choosePlanForOrg: 'Elige un plan para {org}',
    trialEndedAddPayment:
      'Tu prueba gratuita ha terminado. No se eliminó nada: agrega un método de pago y el acceso completo vuelve de inmediato.',
    paymentCouldNotBeProcessed: 'No se pudo procesar el pago',
    activateSubscriptionError:
      'No se pudo activar la suscripción. Verifica los datos de la tarjeta e inténtalo de nuevo.',
    planLabel: 'Plan de suscripción',
    paymentDetails: 'Detalles de pago',
    back: 'Atrás',
    activateSubscription: 'Activar suscripción',
    logout: 'Cerrar sesión',
  },
  // Sprint 30, story-151. Mirrors en.ts's `calculators` section key-for-key. Terminology
  // decided in docs/ux/i18n-house-style.md §10 — see that section for the per-term reasoning
  // (neutral Latin-American Spanish, tú register n/a here since these are labels not
  // sentences, sentence case per §9, gender agreement in every "{Material} Needed" style
  // result label per §10.5's phrase-ownership warning).
  calculators: {
    names: {
      concrete: 'Calculadora de concreto',
      concreteDescription: 'Calcula el volumen de concreto para diversas estructuras',
      plumbing: 'Calculadora de plomería',
      plumbingDescription: 'Análisis de flujo nodal con cálculo de pérdida por fricción',
      electrical: 'Calculadora eléctrica',
      electricalDescription: 'Calibrado de cables, interruptores y lista de materiales conforme a NEC',
      retainingWall: 'Calculadora de muro de contención',
      retainingWallDescription: 'Calcula bloques y grava para muros de contención',
      tile: 'Calculadora de baldosas',
      tileDescription: 'Calcula baldosas, lechada y cajas necesarias',
      flooring: 'Calculadora de piso',
      flooringDescription: 'Calcula los materiales de piso y las cajas necesarias',
      paint: 'Calculadora de pintura',
      paintDescription: 'Calcula los galones de pintura necesarios para pintar una habitación',
      framing: 'Calculadora de entramado',
      framingDescription: 'Calcula postes y soleras para el entramado de paredes',
      selectCalculator: 'Seleccionar calculadora',
      selectCalculatorPlaceholder: 'Selecciona una calculadora...',
    },
    dimensions: {
      length: 'Largo',
      lengthFt: 'Largo (ft)',
      width: 'Ancho',
      widthFt: 'Ancho (ft)',
      height: 'Alto',
      heightFt: 'Alto (ft)',
      thickness: 'Espesor',
      thicknessIn: 'Espesor (in)',
      diameter: 'Diámetro',
      diameterIn: 'Diámetro (in)',
      wasteAllowancePct: 'Factor de desperdicio (%)',
      roomDimensionsFt: 'Dimensiones de la habitación (en pies)',
      roomArea: 'Área de la habitación:',
      cubicYards: 'yardas cúbicas',
      sqFt: 'ft²',
      wallLengthFt: 'Largo del muro (ft)',
    },
    materials: {
      concrete: 'Concreto',
      rebar: 'Varilla',
      mortar: 'Mortero',
      gravel: 'Grava',
      tile: 'Baldosa',
      grout: 'Lechada',
      paint: 'Pintura',
      primer: 'Imprimante',
      framingLumber: 'Madera de entramado',
      conduit: 'Conducto',
      pipe: 'Tubería',
      pipeIndividual: 'Tubo',
      wire: 'Cable',
      wireGauge: 'Calibre del cable',
      retainingWall: 'Muro de contención',
      studs: 'Postes',
      plates: 'Soleras',
      flooring: 'Piso',
    },
    actions: {
      calculate: 'Calcular',
      clear: 'Limpiar',
      result: 'Resultado',
      results: 'Resultados',
      addToMaterial: 'Agregar a materiales',
      add: 'Agregar',
      addRun: 'Agregar tramo',
      cancel: 'Cancelar',
      deleteRun: 'Eliminar tramo',
      note: 'Nota:',
      addAllMaterials: 'Agregar todos los materiales',
      items: 'artículos',
      billOfMaterialsSummary: 'Resumen de la lista de materiales',
      coverage: 'Cobertura',
      examplePrefix: 'ej.',
    },
    counts: {
      doors: 'Número de puertas',
      windows: 'Número de ventanas',
      corners: 'Número de esquinas',
      coats: 'Número de manos',
      steps: 'Número de escalones',
    },
    concrete: {
      selectWhatToCalculate: 'Selecciona qué calcular:',
      concreteNeeded: 'Concreto necesario:',
      types: {
        slab: 'Losa',
        sidewalk: 'Acera',
        footer: 'Zapata',
        column: 'Columna',
        tube: 'Tubo',
        stairs: 'Escalones',
        curb: 'Bordillo',
        gutterBarrier: 'Barrera de cuneta',
      },
      shapes: {
        round: 'Redonda',
        square: 'Cuadrada / rectangular',
      },
      riserHeightIn: 'Altura de la contrahuella (in)',
      treadDepthIn: 'Profundidad de la huella (in)',
      stepWidthFt: 'Ancho del escalón (ft)',
      columnShape: 'Forma de la columna',
      side1In: 'Lado 1 (in)',
      side2In: 'Lado 2 (in)',
      wallThicknessIn: 'Espesor de la pared (in)',
      curbDepthIn: 'Profundidad del bordillo (in)',
      curbHeightIn: 'Altura del bordillo (in)',
      gutterWidthIn: 'Ancho de la cuneta (in)',
      flagThicknessIn: 'Espesor de la losa (in)',
      dimensionsHeadingSlab: 'Dimensiones de la losa',
      dimensionsHeadingSidewalk: 'Dimensiones de la acera',
      dimensionsHeadingFooter: 'Dimensiones de la zapata',
      dimensionsHeadingStairs: 'Dimensiones de los escalones',
      dimensionsHeadingColumn: 'Dimensiones de la columna',
      dimensionsHeadingTube: 'Dimensiones del tubo',
      dimensionsHeadingCurb: 'Dimensiones del bordillo',
      dimensionsHeadingGutterBarrier: 'Dimensiones de la barrera de cuneta',
      dimensionsHeadingDefault: 'Dimensiones',
    },
    retainingWall: {
      wallBlockDimensions: 'Dimensiones del muro y del bloque',
      wallHeightFt: 'Alto del muro (ft)',
      blockLengthIn: 'Largo del bloque (in)',
      blockHeightIn: 'Alto del bloque (in)',
      includeCapRow: '¿Incluir una hilada de remate?',
      gravelBackfill: 'Relleno de grava',
      wallBlocks: 'Bloques del muro:',
      capBlocks: 'Bloques de remate:',
      totalBlocks: 'Bloques totales:',
      gravelNeeded: 'Grava necesaria:',
      gravelWeight: 'Peso de la grava:',
      wallBlocksMaterial: 'Bloques del muro',
      blocksUnitOne: 'bloque',
      blocksUnitOther: 'bloques',
    },
    tile: {
      tileAndGroutDimensions: 'Dimensiones de la baldosa y la lechada',
      tileLengthIn: 'Largo de la baldosa (en pulgadas)',
      tileWidthIn: 'Ancho de la baldosa (en pulgadas)',
      groutJointWidthIn: 'Ancho de la junta de lechada (en pulgadas)',
      additionalInformation: 'Información adicional',
      tilesPerBox: 'Baldosas por caja',
      calculateButton: 'Calcular baldosas y lechada',
      tilesNeeded: 'Baldosas necesarias (aprox.):',
      groutNeeded: 'Lechada necesaria:',
      groutNeededUnit: 'lb (aprox.)',
      boxesOfTiles: 'Cajas de baldosas:',
      tileBoxesMaterial: 'Cajas de baldosas',
      tilesUnitOne: 'baldosa',
      tilesUnitOther: 'baldosas',
      boxesUnitOne: 'caja',
      boxesUnitOther: 'cajas',
    },
    flooring: {
      wasteAndBoxInformation: 'Información de desperdicio y cajas',
      sqftPerBox: 'Pies² por caja',
      woodPlankDimensions: 'Dimensiones de la tabla de madera (opcional)',
      plankLengthIn: 'Largo de la tabla (en pulgadas)',
      plankWidthIn: 'Ancho de la tabla (en pulgadas)',
      calculateButton: 'Calcular piso',
      flooringNeeded: 'Piso necesario:',
      boxesNeeded: 'Cajas necesarias:',
      planksNeeded: 'Tablas necesarias (aprox.):',
      flooringBoxesMaterial: 'Cajas de piso',
      flooringPlanksMaterial: 'Tablas de piso',
      boxesUnitOne: 'caja',
      boxesUnitOther: 'cajas',
      planksUnitOne: 'tabla',
      planksUnitOther: 'tablas',
    },
    paint: {
      doorsAndWindowsCount: 'Puertas y ventanas (cantidad)',
      paintInformation: 'Información de la pintura',
      coverageSqFtGallon: 'Cobertura (ft² / galón)',
      calculateButton: 'Calcular pintura',
      totalPaintableArea: 'Área total a pintar:',
      gallonsNeeded: 'Galones necesarios:',
      unitGallonOne: 'galón',
      unitGallonOther: 'galones',
    },
    framing: {
      wallInformation: 'Información del muro',
      wallLengthInFeet: 'Largo del muro (en pies)',
      studSpacingIn: 'Separación de postes (en pulgadas)',
      openingsAndCorners: 'Aberturas y esquinas',
      calculateButton: 'Calcular entramado',
      totalStudsNeeded: 'Postes totales necesarios:',
      totalPlateLumber: 'Madera de solera total:',
      plateLumberUnit: 'pies lineales (asumiendo 3 soleras)',
      wallStudsMaterial: 'Postes del muro',
      plateLumberMaterial: 'Madera de solera',
      studsUnitOne: 'poste',
      studsUnitOther: 'postes',
    },
    plumbing: {
      subtitle: 'Análisis de flujo nodal con pérdida por fricción de Hazen-Williams',
      materialCopperL: 'Cobre tipo L',
      fixtureToiletHe: 'Inodoro (alta eficiencia)',
      fixtureShower: 'Ducha',
      fixtureKitchenSink: 'Fregadero de cocina',
      fixtureLavatory: 'Lavamanos',
      fixtureGardenTub: 'Bañera tipo jardín',
      mainTrunk: 'Tubería principal',
      sourcePressurePsi: 'Presión de la fuente (PSI)',
      allRunsAdequatePressure: 'Todos los tramos tienen presión adecuada',
      someRunsLowPressure: 'Algunos tramos tienen baja presión',
      pipeRuns: 'Tramos de tubería',
      newPipeRun: 'Nuevo tramo de tubería',
      runLabel: 'Nombre del tramo',
      exampleRunLabel: 'ej., Ramal del baño',
      pipeMaterial: 'Material de la tubería',
      pipeSize: 'Tamaño de la tubería',
      fixtureType: 'Tipo de artefacto',
      fixtureCount: 'Cantidad de artefactos',
      elbows90: 'Codos de 90°',
      elbows45: 'Codos de 45°',
      teesLineBranch: 'Tes (línea/ramal)',
      teeLinePlaceholder: 'Línea',
      teeBranchPlaceholder: 'Ramal',
      supply: 'Suministro',
      size: 'Tamaño',
      fixture: 'Artefacto',
      elbows9045: 'Codos de 90° / 45°',
      endPressure: 'Presión final',
      effectiveLength: 'Longitud efectiva:',
      pipeInventory: 'Inventario de tubería',
      fittingInventory: 'Inventario de accesorios',
      teeFittings: 'Tes',
      criticalPressureDrop: 'Caída crítica de presión',
      engineeringNote:
        'Una Te de flujo lateral genera 6 veces más fricción que una Te de flujo en línea. Usa tramos rectos para las líneas principales para conservar la presión. La presión final mínima recomendada es de 30 PSI.',
      fittingUnitOne: 'unidad',
      fittingUnitOther: 'unidades',
    },
    electrical: {
      subtitle: 'Calculadora de dimensionamiento de cable y lista de materiales conforme al NEC 2023',
      materialCopper: 'Cobre',
      materialAluminum: 'Aluminio',
      kitchenCircuit: 'Circuito de la cocina',
      wireTypeThhn: 'THHN (conducto)',
      protectionStandard: 'Estándar',
      protectionDual: 'Doble (GFCI + AFCI)',
      ambientStandard: 'Estándar (86°F)',
      ambientWarm: 'Cálido (104°F)',
      ambientHotAttic: 'Ático caliente (122°F)',
      ambientExtreme: 'Extremo (140°F)',
      maxDropRecommended: '2% (recomendado)',
      maxDropNecMax: '3% (máx. NEC)',
      maxVoltageDropAllowed: 'Caída de voltaje máxima permitida',
      allRunsSafe: 'Todos los tramos son seguros',
      someRunsNeedAttention: 'Algunos tramos necesitan atención',
      wireRuns: 'Tramos de cable',
      newWireRun: 'Nuevo tramo de cable',
      circuitLabel: 'Nombre del circuito',
      wireMaterial: 'Material del cable',
      exampleCircuitLabel: 'ej., Circuito de la cocina',
      voltage: 'Voltaje',
      loadCurrentA: 'Corriente de carga (A)',
      runLengthFt: 'Longitud del tramo (ft)',
      wireType: 'Tipo de cable',
      protectionType: 'Tipo de protección',
      ambientTemperature: 'Temperatura ambiente',
      autoFixWireGauge: 'Corregir automáticamente el calibre',
      gauge: 'Calibre',
      current: 'Corriente',
      typeLabel: 'Tipo',
      temp: 'Temp.',
      protection: 'Protección',
      dropSuffix: 'de caída',
      breaker: 'Interruptor:',
      limit: 'Límite:',
      cond: 'Cond.:',
      wireInventory: 'Inventario de cable',
      conduitTenFtSticks: 'Conducto (tramos de 10 ft)',
      sticksLabel: 'tramos',
      breakers: 'Interruptores',
      breakerMaterial: 'Interruptor',
    },
  },
  // Sprint 30, story-152. Mirrors en.ts's `warehouse` section key-for-key. Terminology per
  // docs/ux/i18n-house-style.md §12.
  warehouse: {
    genericUnitPlural: 'unidades',
    genericUnitSingular: 'unidad',
    materialSelection: 'Selección de material',
    selectMaterialRequired: 'Selecciona un material *',
    searchOrSelectMaterial: 'Busca o selecciona un material...',
    noMaterialsFound: 'No se encontraron materiales',
    warehouseRequired: 'Almacén *',
    warehouseLabel: 'Almacén',
    selectWarehousePlaceholder: 'Selecciona el almacén...',
    currentStock: 'Existencias actuales',
    reorderPoint: 'Punto de reorden',
    quantityRequired: 'Cantidad *',
    detailsRequired: 'Detalles *',
    resultPreview: 'Vista previa del resultado',
    afterAdjustment: 'Después del ajuste',
    criticalLowStockWarning: 'Advertencia de existencias críticamente bajas',
    foundExtraInventory: 'Se encontró inventario adicional',
    damagedLostStolen: 'Dañado, perdido o robado',
    receiveStock: 'Recibir existencias',
    adjustment: {
      title: 'Ajustar existencias',
      description: 'Realiza correcciones a los conteos de inventario',
      applying: 'Aplicando...',
      applyAdjustment: 'Aplicar ajuste',
      warningIntro:
        'Los ajustes de existencias deben usarse solo para correcciones (dañado, perdido, encontrado, errores de conteo). Usa',
      warningMiddle: 'para inventario nuevo y',
      taskConsumptionLink: 'consumo de tarea',
      warningEnd: 'para el uso normal.',
      details: 'Detalles del ajuste',
      typeLabel: 'Tipo de ajuste *',
      addToStock: 'Agregar a existencias',
      removeFromStock: 'Quitar de existencias',
      quantityExceedsStock: 'La cantidad supera las existencias actuales. Máximo a retirar:',
      reasonForAdjustment: 'Motivo del ajuste',
      selectReasonPlaceholder: 'Selecciona un motivo...',
      describeReasonPlaceholder: 'Describe el motivo de este ajuste...',
      noteAuditPurposes: 'Esta nota se guardará con fines de auditoría',
      adding: 'Agregando',
      removing: 'Quitando',
      afterAdjustmentStockAt: 'Después de este ajuste, las existencias quedarán en',
      considerOrderingMore: 'Considera pedir más existencias pronto.',
      cannotRemoveMoreThanStock: 'No se puede quitar más de las existencias actuales (',
      toStock: 'a las existencias',
      fromStock: 'de las existencias',
      belowReorderPointOf: 'lo cual está por debajo del punto de reorden de',
      pleaseReduceQuantity: 'Reduce la cantidad.',
    },
    receiptTotal: 'Total de la recepción',
    afterReceipt: 'Después de la recepción',
    currentAvgCost: 'Costo promedio actual',
    newAvgCost: 'Nuevo costo promedio',
    weightedAverageCost: 'Costo promedio ponderado',
    receive: {
      description: 'Registra los materiales entrantes en tu almacén',
      receiving: 'Recibiendo...',
      avgCost: 'Costo prom.',
      supplier: 'Proveedor',
      receiptDetails: 'Detalles de la recepción',
      unitCostRequired: 'Costo unitario *',
      lastCost: 'Último costo:',
      enterSupplierPlaceholder: 'Ingresa el nombre del proveedor...',
      batchReference: 'Referencia del lote (OC/factura)',
      exampleBatchRef: 'ej., OC-2025-0043',
      notes: 'Notas',
      notesPlaceholder: 'Notas adicionales sobre esta recepción...',
      summary: 'Resumen',
      fromCurrent: 'respecto al actual',
      receivedSuccess: 'Existencias recibidas correctamente',
      receiveFailed: 'No se pudieron recibir las existencias',
    },
    unitCost: 'Costo unitario',
    reference: 'Referencia',
    alerts: {
      totalItems: 'Total de artículos',
      lowStockAlerts: 'Alertas de existencias bajas',
      totalValue: 'Valor total',
      reservedValue: 'Valor reservado',
      orderBy: 'Pedir antes de',
      taskStarts: 'Inicio de la tarea',
      supplier: 'Proveedor',
      viewTask: 'Ver tarea',
      reserve: 'Reservar',
      leadTimeSuffix: '(Tiempo de entrega: {n} días)',
      orderTimeline: 'Cronograma del pedido',
      orderByMarker: 'Pedir antes de',
      today: 'Hoy',
      taskStartsMarker: 'Inicio de la tarea',
      availableStock: 'Existencias disponibles',
      needMore: 'Faltan {n} más',
      warehouseLabel: 'Almacén',
      leadTime: 'Tiempo de entrega',
      workingDays: 'días hábiles',
      calendarDaysToTask: 'días calendario para la tarea',
      materialOrderDeadlines: 'Fechas límite de pedido de materiales',
      materialOrderDeadlinesSubtitle: 'Materiales planificados que se acercan a su fecha límite de pedido',
      overdue: 'Atrasado',
      urgentOrderSoon: 'Urgente - Pedir pronto',
      upcoming: 'Próximo',
      reserveMaterialTitle: 'Reservar material',
      receiveReserveFailWarn:
        'Se recibieron las existencias, pero no se pudo reservar el material para la tarea. Es posible que no haya suficientes existencias disponibles.',
      reserveFailWarn: 'No se pudo reservar el material. Es posible que no haya suficientes existencias disponibles.',
      taskLabel: 'Tarea',
      orderNow: 'Pedir ahora',
      orderAction: 'Pedir',
      assigned: 'Asignado',
      overdueByOne: 'Atrasado por {n} día hábil',
      overdueByOther: 'Atrasado por {n} días hábiles',
      orderToday: 'Pedir hoy',
      daysLeftOne: 'Queda {n} día hábil',
      daysLeftOther: 'Quedan {n} días hábiles',
      statusOverdueOne:
        'Este pedido de material lleva {n} día hábil de atraso. Pídelo de inmediato para evitar demoras en la tarea.',
      statusOverdueOther:
        'Este pedido de material lleva {n} días hábiles de atraso. Pídelo de inmediato para evitar demoras en la tarea.',
      statusUrgentOne:
        'Solo queda {n} día hábil para hacer este pedido. Actúa pronto para cumplir con el cronograma de la tarea.',
      statusUrgentOther:
        'Solo quedan {n} días hábiles para hacer este pedido. Actúa pronto para cumplir con el cronograma de la tarea.',
      statusUpcomingOne: 'Queda {n} día hábil para la fecha límite del pedido. Planifica tu compra.',
      statusUpcomingOther: 'Quedan {n} días hábiles para la fecha límite del pedido. Planifica tu compra.',
    },
    dashboard: {
      inCatalog: 'en catálogo',
      needReorder: 'necesitan reorden',
      inventoryValueSuffix: 'valor del inventario',
      forActiveTasks: 'para tareas activas',
      stockByCategory: 'Existencias por categoría',
      noStockData: 'No hay datos de existencias disponibles',
      viewAll: 'Ver todo',
      order: 'Pedir',
      onHandSuffix: 'en existencia',
      reorderColon: 'Reorden:',
      noLowStockAlerts: 'No hay alertas de existencias bajas',
      recentTransactions: 'Movimientos recientes',
      viewAllTransactions: 'Ver todos los movimientos',
      date: 'Fecha',
      typeColumn: 'Tipo',
      noRecentTransactions: 'No hay movimientos recientes',
      currentStockLevels: 'Niveles de existencias actuales',
      category: 'Categoría',
      onHand: 'Existencias',
      available: 'Disponible',
      noStockLevelsAvailable: 'No hay niveles de existencias disponibles',
      showing10Of: 'Mostrando 10 de',
      materials: 'materiales',
    },
    forms: {
      editMaterialTitle: 'Editar material',
      addMaterialTitle: 'Agregar material nuevo',
      saveChanges: 'Guardar cambios',
      addMaterial: 'Agregar material',
      autoGeneratingSku: 'Generando automáticamente...',
      typeNameFirst: 'Escribe el nombre primero',
      costCalculatedFromTransactions: 'El costo se calcula a partir de las transacciones',
      yourPurchaseCost: 'Tu costo de compra',
      chooseWarehouseForStock: 'Elige dónde se guardarán estas existencias',
      customSkuHint: 'SKU personalizado: haz clic en actualizar para generarlo automáticamente',
      autoGeneratedFromNameCategory: 'Generado automáticamente a partir del nombre y la categoría',
      marginNotCalculable: '-- (define los precios para calcular)',
      basicInformation: 'Información básica',
      nameRequired: 'Nombre *',
      exampleMaterialName: 'ej., Cemento Portland',
      skuInternalCode: 'SKU (código interno)',
      regenerateSku: 'Regenerar SKU',
      selectCategoryPlaceholder: 'Selecciona la categoría...',
      defaultSupplier: 'Proveedor predeterminado',
      exampleSupplierName: 'ej., Holcim',
      additionalDetailsMaterial: 'Detalles adicionales sobre este material...',
      unitsAndMeasurement: 'Unidades y medición',
      system: 'Sistema',
      metricImperialPlaceholder: 'Métrico/Imperial',
      defaultUnit: 'Unidad predeterminada',
      selectUnitPlaceholder: 'Selecciona la unidad...',
      pricing: 'Precios',
      defaultCostPerUnit: 'Costo predeterminado por unidad',
      defaultPricePerUnit: 'Precio predeterminado por unidad',
      priceChargedToClients: 'Precio cobrado a los clientes',
      estimatedMargin: 'Margen estimado:',
      stockAlerts: 'Alertas de existencias',
      alertBelowQuantity: 'Alerta cuando las existencias caigan por debajo de esta cantidad',
      suggestedOrderQty: 'Cant. sugerida a pedir',
      suggestedQtyHelp: 'Cantidad sugerida para pedir cuando esté bajo',
      leadTimeDays: 'Tiempo de entrega (días)',
      leadTimeHelp: 'Días necesarios para pedir antes de que se necesite en el sitio',
      initialStock: 'Existencias iniciales',
      initialStockHelp:
        'Si ya tienes existencias de este material, puedes agregar la cantidad inicial aquí. Esto creará automáticamente un movimiento de "Recepción".',
      initialQuantity: 'Cantidad inicial',
      selectWarehouseHelp:
        'Selecciona el almacén donde se guardan estas existencias. Ya no se elige por ti — las existencias registradas en el almacén incorrecto parecen faltantes al agregarlas a una tarea.',
      activeStatus: 'Estado activo',
      inactiveHelp: 'Los materiales inactivos no aparecerán en las listas de selección',
    },
    equipmentDetail: {
      updatedSuccess: 'Equipo actualizado correctamente',
      updateFailed: 'No se pudo actualizar el equipo',
      checkedOutSuccess: 'Equipo retirado correctamente',
      checkoutFailed: 'No se pudo retirar el equipo',
      returnedSuccess: 'Equipo devuelto correctamente',
      returnFailed: 'No se pudo devolver el equipo',
      reservedSuccess: 'Equipo reservado correctamente',
      reserveFailed: 'No se pudo reservar el equipo',
      reservationCancelledSuccess: 'Reserva cancelada correctamente',
      cancelReservationFailed: 'No se pudo cancelar la reserva',
      setMaintenanceSuccess: 'Equipo puesto en mantenimiento',
      setMaintenanceFailed: 'No se pudo establecer el estado de mantenimiento',
      completeMaintenanceSuccess: 'Mantenimiento completado - el equipo ya está disponible',
      completeMaintenanceFailed: 'No se pudo completar el mantenimiento',
      notFound: 'Equipo no encontrado',
      backToEquipment: 'Volver a equipo',
      equipmentBreadcrumb: 'Equipo',
      created: 'Creado',
      checkout: 'Retirar',
      reserve: 'Reservar',
      maintenance: 'Mantenimiento',
      return: 'Devolver',
      completeMaintenance: 'Completar mantenimiento',
      serialNumber: 'Número de serie',
      totalHoursUsed: 'Total de horas usadas',
      costPerHour: 'Costo/hora',
      pricePerHour: 'Precio/hora',
      currentlyInUse: 'En uso actualmente',
      taskColon: 'Tarea:',
      projectColon: 'Proyecto:',
      taskIdColon: 'ID de tarea:',
      currentlyInMaintenance: 'En mantenimiento actualmente',
      estimatedAvailableColon: 'Disponible estimado:',
      notesColon: 'Notas:',
      sinceColon: 'Desde:',
      activeReservations: 'Reservas activas',
      equipmentHasReservationsTitle: 'Este equipo tiene reservas activas',
      activeReservationOne: '{n} reserva activa',
      activeReservationOther: '{n} reservas activas',
      equipmentHasReservationsBody:
        'Este equipo tiene {reservations}. Permanecerán activas, pero el equipo no estará disponible para retirar hasta que se complete el mantenimiento.',
      inUseTag: '[En uso]',
      details: 'Detalles',
      manufacturer: 'Fabricante',
      model: 'Modelo',
      purchaseDate: 'Fecha de compra',
      purchaseCost: 'Costo de compra',
      storageLocation: 'Ubicación de almacenamiento',
      lastMaintenance: 'Último mantenimiento',
      estimatedAvailable: 'Disponible estimado',
      notes: 'Notas',
      reservationCalendar: 'Calendario de reservas',
      usageHistory: 'Historial de uso',
      noUsageHistory: 'Aún no se ha registrado historial de uso.',
      taskProject: 'Tarea / Proyecto',
      hours: 'Horas',
      condition: 'Condición',
      cost: 'Costo',
      user: 'Usuario',
      inUseLowercase: 'En uso',
      showing: 'Mostrando',
      to: 'a',
      of: 'de',
      cancelReservationTitle: 'Cancelar reserva',
      cancelReservationDescription:
        '¿Seguro que quieres cancelar esta reserva? El equipo quedará disponible para otras tareas.',
    },
    valuation: {
      totalStock: 'Existencias totales',
      weightedAvgCost: 'Costo promedio ponderado',
      inventoryValue: 'Valor del inventario',
      current: 'Actual:',
      qtyXWac: 'Cant. x costo prom. ponderado',
      totalConsumed: 'Total consumido',
      wacCalculation: 'Cálculo del costo promedio ponderado',
      wacFormula: 'Costo promedio ponderado = Valor total de compra / Cantidad total comprada',
      purchaseHistory: 'Historial de compras',
      noPurchaseTransactions: 'No se registraron compras',
      totalPurchased: 'Total comprado',
      wacColon: 'Costo prom. pond.:',
      usageHistory: 'Historial de uso',
      noUsageTransactions: 'No se registró historial de uso',
      projectTask: 'Proyecto / Tarea',
      costByProject: 'Costo por proyecto',
      quantityUsed: 'Cantidad utilizada',
      totalCost: 'Costo total',
      draws: 'Retiros',
      inventoryValuationReport: 'Reporte de valoración del inventario',
      asOf: 'Al',
      exportPdf: 'Exportar PDF',
      totalInventoryValue: 'Valor total del inventario',
      activeCatalogItems: 'artículos activos del catálogo',
      totalConsumedValue: 'Valor total consumido',
      materialsDrawnToProjects: 'materiales retirados para proyectos',
      equipmentAssets: 'Activos de equipo',
      assetsTotal: 'activos en total',
      valuationByCategory: 'Valoración por categoría',
      items: 'Artículos',
      pctOfTotal: '% del total',
      totalMaterials: 'Total de materiales',
      detailedInventoryBreakdown: 'Desglose detallado del inventario',
      clickMaterialHelp:
        'Haz clic en un material para ver los detalles del costo promedio ponderado, el historial de compras y el costeo por proyecto',
      qtyOnHand: 'Existencias',
      avgUnitCost: 'Costo unitario prom.',
      noInventoryData: 'No hay datos de inventario disponibles',
      materialCostByProject: 'Costo de materiales por proyecto',
      totalMaterialConsumedPerProject: 'Total de material consumido por proyecto al costo promedio ponderado',
      totalMaterialCost: 'Costo total de materiales',
      itemsSuffix: 'artículos',
    },
  },
  // Sprint 32, story-165. Asistente de "pregunta sobre tu proyecto" — tabla de i18n de
  // docs/ux/story-165-design.md.
  assistant: {
    navTitle: 'Asistente',
    pageTitle: 'Asistente',
    emptyStateTitle: 'Pregunta sobre tus proyectos, turnos, tareas o incidentes.',
    examplePrompt1: '¿Quién está en la obra mañana?',
    examplePrompt2: '¿Qué está bloqueando la tarea "{task}"?',
    examplePrompt3: '¿Qué proyectos tuvieron accidentes este trimestre?',
    chatPlaceholder: 'Escribe tu pregunta...',
    youLabel: 'Tú',
    assistantLabel: 'Asistente',
    send: 'Enviar',
    thinking: 'Pensando...',
    lookedAt: 'Consultó: {tools}',
    newChat: 'Nuevo chat',
    history: 'Historial',
    deleteConversationTitle: '¿Eliminar esta conversación?',
    deleteConversationBody: 'Esta acción no se puede deshacer.',
    confirm: 'Confirmar',
    dismiss: 'Descartar',
    actionExecuted: 'Acción realizada: {summary}',
    actionDismissed: 'Descartado: {type}',
    retry: 'Reintentar',
    actionAddNote: 'Agregar nota',
    actionReportIncident: 'Reportar incidente',
    actionChangeTaskStatus: 'Cambiar estado de la tarea',
    actionAcknowledgeIncident: 'Reconocer incidente',
    actionShiftTask: 'Mover tarea',
    actionAssignCrewToTask: 'Asignar cuadrilla a la tarea',
    actionAssignEmployeeToCrew: 'Asignar empleado a la cuadrilla',
    errorNotConfigured: 'El asistente no está disponible en este momento.',
    errorBusy: 'El asistente todavía está trabajando en tu último mensaje.',
    errorDailyMessageCap: 'Tu organización alcanzó el límite de mensajes de hoy. Intenta de nuevo mañana.',
    errorMaxTurns: 'Esta conversación alcanzó su límite. Inicia un chat nuevo para continuar.',
    errorNotFound: 'No se encontró esa conversación.',
    errorNoPendingAction: 'No hay nada que confirmar en este momento.',
    errorActionStale: 'Esto cambió desde que se propuso, así que no se aplicó. Vuelve a preguntar para intentarlo de nuevo.',
    errorInvalidTimezone: 'No pudimos leer la zona horaria de tu dispositivo. Intenta de nuevo.',
    errorMessageTooLong: 'Ese mensaje es demasiado largo. Intenta acortarlo.',
    errorTimeout: 'El asistente tardó demasiado en responder.',
    errorRefused: 'El asistente no pudo responder eso.',
    errorTruncated: 'La respuesta del asistente se cortó.',
    errorRateLimited: 'Demasiadas solicitudes en este momento. Intenta de nuevo en un momento.',
    errorUpstream: 'Algo salió mal de nuestro lado.',
    aboutProject: 'Acerca de: {project}',
    leaveProjectChat: 'Salir del chat del proyecto',
    askAssistant: 'Preguntar al asistente',
    askAssistantTooltip: 'Pregunta al asistente sobre este proyecto',
    untitled: 'Nuevo chat',
    listEmpty: 'Aún no hay conversaciones. Empieza una abajo.',
    listError: 'No se pudieron cargar las conversaciones',
    welcomeTitle: '¿En qué puedo ayudarte hoy?',
    notFoundTitle: 'No se encontró esa conversación.',
    notFoundBody: 'Puede que se haya eliminado. Inicia un chat nuevo para continuar.',
    startNewChat: 'Iniciar un chat nuevo',
    errorUnavailable: 'El asistente no está disponible temporalmente. Se notificó a un administrador.',
  },
  // Sprint 33, story-169/170. End-of-day site report — docs/ux/story-169-design.md,
  // docs/ux/story-170-design.md.
  dailySiteReport: {
    cardTitle: 'Reporte diario de obra',
    cardDescription: 'Recibe un correo cada tarde con lo que pasó en tus proyectos.',
    emailToggleLabel: 'Enviarme el reporte diario por correo',
    toggleOnToast: 'Correo del reporte diario activado',
    toggleOffToast: 'Correo del reporte diario desactivado',
    toggleErrorToast: 'No se pudo guardar. Intenta de nuevo.',
    sendNowButton: 'Enviarme el reporte de hoy ahora',
    sendNowRemainingOne: 'Queda {n} hoy',
    sendNowRemainingOther: 'Quedan {n} hoy',
    sendNowSending: 'Enviando…',
    sendNowError: 'No se pudo enviar el reporte. Intenta de nuevo.',
    sendNowOfflineHint: 'Estás sin conexión. Conéctate para enviar un reporte ahora.',
    orgSectionTitle: 'Horario de la organización',
    orgDisabledBanner: 'Los reportes diarios están desactivados para tu organización hasta que elijas una zona horaria.',
    timezoneLabel: 'Zona horaria',
    sendHourLabel: 'Enviar a las',
    saveScheduleButton: 'Guardar horario',
    scheduleSavedToast: 'Horario de la organización guardado',
    errorInvalidTimezone: 'Esa no es una zona horaria válida.',
    errorInvalidSendHour: 'Elige una hora entre 12 a. m. y 11 p. m.',
    errorNotConfigured: 'Tu organización todavía no eligió una zona horaria. Pídele a un propietario o administrador que la configure.',
    errorQuotaExceeded: 'Ya enviaste 3 reportes hoy. Intenta de nuevo mañana.',
    listTitle: 'Reportes diarios',
    emptyTitleGeneric: 'Todavía no hay reportes',
    emptyBodyScheduled: 'Tu próximo reporte llegará {when}.',
    emptyBodyNoTimezone: 'Los reportes diarios están desactivados para tu organización. Pídele a un propietario o administrador que configure una zona horaria en su perfil.',
    triggerScheduled: 'Programado',
    triggerManual: 'Manual',
    statusPending: 'Pendiente',
    statusSent: 'Enviado',
    statusFailed: 'Fallido',
    statusSkippedEmpty: 'Omitido — nada que reportar',
    statusSkippedOptedOut: 'Omitido — correo desactivado',
    errorRowNotice: 'El correo de este reporte no se pudo enviar: "{message}". El contenido de abajo se generó, pero nunca se envió.',
    truncatedNote: 'Mostrando los primeros {n}. Algunos elementos no se muestran.',
    notFoundTitle: 'Reporte no encontrado',
    notFoundBody: 'Este reporte no existe o no tienes acceso para verlo.',
    backToList: 'Volver a Reportes diarios',
    offlineBanner: 'Sin conexión — mostrando reportes guardados',
    offlineDetailUnavailable: 'Este reporte todavía no está disponible sin conexión. Conéctate para cargarlo.',
    section1Title: 'Cambios de estado y tareas completadas',
    section2Title: 'Incidentes',
    section3Title: 'Horas de la cuadrilla',
    section4Title: 'Notas, documentos y existencias',
    section4Notes: 'Notas',
    section4Documents: 'Documentos',
    section4Stock: 'Existencias',
    section5Title: 'Próximamente',
    section5TitleWithDate: 'Próximamente — mañana, {date}',
    lookingAheadStarting: 'Inicia: {task} — {project}',
    lookingAheadDue: 'Vence: {task} — {project}',
    lookingAheadPendingOne: '1 incidente pendiente',
    lookingAheadPendingOther: '{n} incidentes pendientes',
    nothingToReport: 'Nada que reportar.',
    stillOnSite: 'todavía en el sitio',
    adjusted: '(ajustado)',
    sendHourAriaLabel: 'Hora de envío',
    noteExcerptTemplate: '«{excerpt}»',
    countStatusChangesLabel: 'cambios de estado',
    countIncidentsLabel: 'incidentes',
    countDocumentsLabel: 'documentos',
    countStatusChangesLabelSingular: 'cambio de estado',
    countIncidentsLabelSingular: 'incidente',
    countDocumentsLabelSingular: 'documento',
    taskStatusActive: 'Activa',
    taskStatusInactive: 'Inactiva',
    taskStatusComplete: 'Completa',
    taskStatusRejected: 'Rechazada',
    taskStatusCanceled: 'Cancelada',
    taskStatusInternalApproval: 'Aprobación interna',
    taskStatusClientApproval: 'Aprobación del cliente',
    taskStatusDelegationCanceled: 'Delegación cancelada',
    incidentTypeWeather: 'Clima',
    incidentTypeAccident: 'Accidente',
    incidentTypeMaterialsIssue: 'Problema de Materiales',
    incidentTypeEquipmentIssue: 'Problema de Equipo',
    incidentTypeOther: 'Otro',
    incidentStatusAcknowledged: 'Reconocido',
    txTypeReceive: 'Recibido',
    txTypeConsume: 'Consumido',
    txTypeAdjust: 'Ajustado',
    txTypeReturn: 'Devuelto',
    txTypeRecovery: 'Recuperado',
    txTypeTransfer: 'Transferido',
    txTypeUseAsEquipment: 'Equipo',
    // Sprint 38, story-204/205/206/207.
    emptyBodyScheduledFallback: 'Tus reportes llegan según el horario diario de tu organización.',
    nextSendToday: 'hoy a las {time}',
    nextSendTomorrow: 'mañana a las {time}',
    nextSendWeekday: 'el {day} a las {time}',
    nextSendDate: 'el {date} a las {time}',
    errorNotEligible: 'Los reportes diarios no están disponibles para tu cuenta.',
    ineligibleNoRole: 'No eres miembro de esta organización, por lo que no hay reporte para enviar.',
    ineligibleClientNoActivityAccess:
      'Tu acceso no incluye la actividad del proyecto, por lo que los reportes diarios no están disponibles. Pide al equipo del proyecto que active el acceso a la actividad.',
    ineligibleClientNoLinkedClient:
      'Tu cuenta aún no está vinculada a un registro de cliente, por lo que no hay nada que reportar. Contacta al equipo del proyecto.',
    incidentTypeOtherNamed: 'Otro: {type}',
    incidentReportedBy: 'Reportado por {name}',
    incidentDelay: 'Retraso: {n} {unit}',
    delayUnitHoursOne: 'hora',
    delayUnitHoursOther: 'horas',
    delayUnitDaysOne: 'día',
    delayUnitDaysOther: 'días',
    delayUnitWeeksOne: 'semana',
    delayUnitWeeksOther: 'semanas',
    incidentOpenedToday: 'abierto hoy',
    incidentDaysOpenOne: '1 día abierto',
    incidentDaysOpenOther: '{n} días abiertos',
    pendingIncidentsTitle: 'Incidentes pendientes',
    cardGeneral: 'Elementos generales',
    cardIncidentsBadgeOne: '1 incidente',
    cardIncidentsBadgeOther: '{n} incidentes',
    cardToggleAria: 'Alternar {project}',
    tableName: 'Nombre',
    tableHours: 'Horas',
    hoursValue: '{n} h',
  },
  clientProgress: {
    healthOnTrack: 'En tiempo',
    healthBehind: 'Atrasado',
    healthNotStarted: 'Sin iniciar',
    healthComplete: 'Completado',
    healthNone: 'Aún sin tareas',
    tasksOfTotal: '{complete} de {countable} tareas',
    tasksOfTotalComplete: '{complete} de {countable} tareas completadas',
    allComplete: 'Las {n} tareas están completadas',
    percentComplete: '{pct} %',
    overdueOne: '{n} atrasada',
    overdueOther: '{n} atrasadas',
    dueThisWeekOne: '{n} vence esta semana',
    dueThisWeekOther: '{n} vencen esta semana',
    awaitingApprovalOne: '{n} espera tu aprobación',
    awaitingApprovalOther: '{n} esperan tu aprobación',
    openIncidentOne: '{n} incidente abierto',
    openIncidentOther: '{n} incidentes abiertos',
    tileOverdue: 'Atrasadas',
    tileDueThisWeek: 'Vencen esta semana',
    tileAwaitingApproval: 'Esperan tu aprobación',
    tileOpenIncidents: 'Incidentes abiertos',
    nextUp: 'Próximos pasos',
    milestoneStarts: 'Inicia',
    milestoneDue: 'Vence',
    lastActivity: 'Última actividad: {when}',
    lastActivityToday: 'hoy',
    lastActivityYesterday: 'ayer',
    lastActivityDaysAgo: 'hace {n} días',
    attentionTitle: 'Requiere tu atención',
    attentionApprovalOne: '{n} tarea espera tu aprobación',
    attentionApprovalOther: '{n} tareas esperan tu aprobación',
    attentionIncidentOne: '{n} incidente abierto',
    attentionIncidentOther: '{n} incidentes abiertos',
    attentionMore: '+{n} más',
    openProject: 'Abrir {name}',
    unavailable: 'El avance no está disponible en este momento.',
    retry: 'Reintentar',
    groupAwaiting: 'Esperando tu aprobación',
    groupInProgress: 'En curso',
    groupUpcoming: 'Próximas',
    groupComplete: 'Completadas',
    colTiming: 'Plazo',
    daysLateOne: '{n} día de atraso',
    daysLateOther: '{n} días de atraso',
  },
  notFound: {
    code: '404',
    title: 'Página no encontrada',
    body: 'La página que buscas no existe o puede haber cambiado de lugar.',
    goToLogin: 'Ir a iniciar sesión',
    goToHome: 'Ir al inicio',
  },
  // Sprint 47, story-233. One shared password rule; checklist rows and validators read the same keys.
  passwordPolicy: {
    checklistTitle: 'Tu contraseña debe contener:',
    length: 'Al menos 8 caracteres',
    uppercase: 'Una letra mayúscula (A-Z)',
    lowercase: 'Una letra minúscula (a-z)',
    number: 'Un número (0-9)',
    symbol: 'Un símbolo o espacio (cualquiera)',
    edges: 'Sin espacio al inicio ni al final',
    lengthError: 'Usa al menos 8 caracteres.',
    uppercaseError: 'Agrega una letra mayúscula.',
    lowercaseError: 'Agrega una letra minúscula.',
    numberError: 'Agrega un número (0-9).',
    symbolError: 'Agrega un símbolo o un espacio.',
    edgesError: 'Quita el espacio al inicio o al final.',
    tooLong: 'Usa 256 caracteres o menos.',
    required: 'Ingresa una contraseña.',
    confirmRequired: 'Confirma tu contraseña.',
    mismatch: 'Las contraseñas no coinciden.',
  },
  // Sprint 47, story-232. One-time account setup page (/setup).
  setup: {
    title: 'Configura tu cuenta',
    subtitle: 'Elige una contraseña para terminar.',
    checking: 'Verificando tu enlace...',
    emailLabel: 'Correo electrónico',
    passwordLabel: 'Nueva contraseña',
    confirmLabel: 'Confirmar contraseña',
    save: 'Guardar y continuar',
    saving: 'Guardando...',
    expiredTitle: 'Este enlace ha caducado',
    expiredBody:
      'Los enlaces de configuración funcionan durante 7 días. Ingresa tu correo y te enviaremos uno nuevo.',
    usedTitle: 'Este enlace ya se usó',
    usedBody:
      'Si ya definiste tu contraseña, inicia sesión. Si no, ingresa tu correo para recibir un enlace nuevo.',
    invalidTitle: 'Este enlace no es válido',
    invalidBody:
      'Puede que se haya copiado incompleto. Ingresa tu correo y te enviaremos uno nuevo.',
    emailPlaceholder: 'tu@empresa.com',
    resend: 'Envíame un enlace nuevo',
    resendSentTitle: 'Revisa tu correo',
    resendSentBody:
      'Si esa dirección tiene una cuenta pendiente de configurar, un enlace nuevo va en camino. Funciona durante 7 días.',
    resendCooldown: 'Podrás reenviar de nuevo en {seconds} s',
    emailInvalid: 'Ingresa un correo electrónico válido.',
    goToSignIn: 'Ir a iniciar sesión',
    verifyErrorTitle: 'No pudimos verificar tu enlace',
    verifyErrorBody: 'Revisa tu conexión e inténtalo de nuevo.',
    retry: 'Intentar de nuevo',
    doneTitle: 'Todo listo',
    doneBody:
      'Abre la app de ZenHammer e inicia sesión con tu correo y la contraseña que acabas de elegir.',
    appStore: 'Descargar en el App Store',
    playStore: 'Disponible en Google Play',
    networkError: 'Algo salió mal. Revisa tu conexión e inténtalo de nuevo.',
    rateLimited: 'Demasiadas solicitudes. Inténtalo de nuevo en unos minutos.',
    signInFailed: 'Tu contraseña se guardó. Inicia sesión.',
  },
};

export default es;
